import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// ─── Data Dictionaries (WORD_BANK, MATH_LEVELS, TRIVIA_QUESTIONS) ─────────────
const WORD_BANK = [
  // ── Level 1 (3-4 letters, any topic) ──
  { word: "bird", hint: "A feathered creature that can fly", level: 1 },
  { word: "frog", hint: "Green amphibian that jumps", level: 1 },
  { word: "lamp", hint: "A device that gives light", level: 1 },
  { word: "drum", hint: "A percussion instrument you beat", level: 1 },
  { word: "crab", hint: "Crustacean with claws that walks sideways", level: 1 },
  { word: "gold", hint: "Precious yellow metal", level: 1 },
  { word: "wolf", hint: "Wild relative of the dog", level: 1 },
  { word: "cake", hint: "Sweet baked treat for celebrations", level: 1 },
  { word: "star", hint: "Shining body in the night sky", level: 1 },
  { word: "fish", hint: "Aquatic animal with fins and gills", level: 1 },
  // ── Level 2 (4-5 letters) ──
  { word: "tiger", hint: "Striped big cat from Asia", level: 2 },
  { word: "pizza", hint: "Italian dish with cheese and toppings", level: 2 },
  { word: "cloud", hint: "White or grey mass in the sky", level: 2 },
  { word: "piano", hint: "Large keyboard musical instrument", level: 2 },
  { word: "ocean", hint: "Vast body of salt water", level: 2 },
  { word: "brush", hint: "Tool with bristles for painting or hair", level: 2 },
  { word: "eagle", hint: "Large bird of prey with sharp talons", level: 2 },
  { word: "maple", hint: "Tree famous for its syrup", level: 2 },
  { word: "gecko", hint: "Small lizard that can climb walls", level: 2 },
  { word: "torch", hint: "Portable handheld light source", level: 2 },
  // ── Level 3 (5 letters, varied) ──
  { word: "shark", hint: "Predatory fish with rows of teeth", level: 3 },
  { word: "flute", hint: "Woodwind instrument you blow sideways", level: 3 },
  { word: "denim", hint: "Blue fabric jeans are made from", level: 3 },
  { word: "llama", hint: "South American animal related to camel", level: 3 },
  { word: "solar", hint: "Relating to the sun", level: 3 },
  { word: "tulip", hint: "Spring flower with cup-shaped bloom", level: 3 },
  { word: "prism", hint: "Glass shape that splits light into colours", level: 3 },
  { word: "koala", hint: "Fluffy Australian marsupial in eucalyptus trees", level: 3 },
  { word: "atlas", hint: "A book of maps", level: 3 },
  { word: "coral", hint: "Ocean reef made by tiny marine animals", level: 3 },
  // ── Level 4 (5-6 letters) ──
  { word: "cactus", hint: "Desert plant with sharp spines", level: 4 },
  { word: "magnet", hint: "Object that attracts iron and steel", level: 4 },
  { word: "falcon", hint: "Fast diving bird of prey", level: 4 },
  { word: "walnut", hint: "Wrinkled nut inside a hard shell", level: 4 },
  { word: "frozen", hint: "Turned to ice by cold", level: 4 },
  { word: "rocket", hint: "Vehicle launched into space", level: 4 },
  { word: "pebble", hint: "Small smooth stone", level: 4 },
  { word: "radish", hint: "Small red or white root vegetable", level: 4 },
  { word: "jigsaw", hint: "Puzzle made of interlocking pieces", level: 4 },
  { word: "cobalt", hint: "Vivid blue metallic element", level: 4 },
  // ── Level 5 (6 letters, mixed topics) ──
  { word: "butter", hint: "Dairy spread made from cream", level: 5 },
  { word: "island", hint: "Land entirely surrounded by water", level: 5 },
  { word: "fossil", hint: "Preserved remains of ancient life", level: 5 },
  { word: "cherry", hint: "Small round red or dark fruit", level: 5 },
  { word: "statue", hint: "Carved or moulded figure of a person or animal", level: 5 },
  { word: "pepper", hint: "Common spice used in cooking, can be hot", level: 5 },
  { word: "budget", hint: "Plan for how to spend money", level: 5 },
  { word: "lizard", hint: "Scaly reptile with four legs and a long tail", level: 5 },
  { word: "bridge", hint: "Structure that crosses a gap or river", level: 5 },
  { word: "goblin", hint: "Mischievous creature from folklore", level: 5 },
  // ── Level 6 (6-7 letters) ──
  { word: "dolphin", hint: "Intelligent marine mammal known for leaping", level: 6 },
  { word: "cabinet", hint: "Storage furniture with shelves or drawers", level: 6 },
  { word: "blanket", hint: "Warm covering used in bed", level: 6 },
  { word: "captain", hint: "Leader of a ship, plane, or sports team", level: 6 },
  { word: "channel", hint: "A TV station or a narrow waterway", level: 6 },
  { word: "fiction", hint: "Stories that are imagined, not real", level: 6 },
  { word: "penguin", hint: "Flightless seabird in tuxedo-like colouring", level: 6 },
  { word: "mustard", hint: "Yellow condiment made from seeds", level: 6 },
  { word: "spinner", hint: "Something that rotates around a center", level: 6 },
  { word: "tornado", hint: "Violent rotating column of air", level: 6 },
  // ── Level 7 (7 letters) ──
  { word: "blanket", hint: "Soft covering used for warmth", level: 7 },
  { word: "mystery", hint: "Something unexplained or unknown", level: 7 },
  { word: "compass", hint: "Tool used to find direction using north", level: 7 },
  { word: "lobster", hint: "Large red crustacean with claws", level: 7 },
  { word: "cheddar", hint: "Popular type of yellow cheese", level: 7 },
  { word: "volcano", hint: "Mountain that can erupt with lava", level: 7 },
  { word: "drought", hint: "Long period of very little rainfall", level: 7 },
  { word: "lantern", hint: "Portable container enclosing a light", level: 7 },
  { word: "journal", hint: "A personal diary or scientific publication", level: 7 },
  { word: "panther", hint: "Large black wild cat", level: 7 },
  // ── Level 8 (7-8 letters) ──
  { word: "keyboard", hint: "Input device with keys for typing", level: 8 },
  { word: "calendar", hint: "Chart showing the days and months", level: 8 },
  { word: "avocado", hint: "Green creamy fruit used in guacamole", level: 8 },
  { word: "mushroom", hint: "Fungus with a cap, some edible some not", level: 8 },
  { word: "treasure", hint: "Collection of valuable items or hidden riches", level: 8 },
  { word: "scissors", hint: "Cutting tool with two blades joined in the middle", level: 8 },
  { word: "platform", hint: "Raised level surface or digital system", level: 8 },
  { word: "notebook", hint: "Small book for writing notes", level: 8 },
  { word: "chlorine", hint: "Chemical element used to clean pools", level: 8 },
  { word: "dinosaur", hint: "Ancient reptile that went extinct 65 million years ago", level: 8 },
  // ── Level 9 (8 letters) ──
  { word: "corridor", hint: "A long hallway in a building", level: 9 },
  { word: "broccoli", hint: "Green vegetable shaped like a tree", level: 9 },
  { word: "skeleton", hint: "Framework of bones in a body", level: 9 },
  { word: "software", hint: "Computer programs and operating systems", level: 9 },
  { word: "snowflake", hint: "Unique crystal of frozen water falling from sky", level: 9 },
  { word: "magazine", hint: "Periodical publication with articles and photos", level: 9 },
  { word: "triangle", hint: "Shape with three sides and three angles", level: 9 },
  { word: "molecule", hint: "Smallest unit of a substance with its properties", level: 9 },
  { word: "workshop", hint: "Room or event for hands-on learning or making", level: 9 },
  { word: "flagship", hint: "Most important product or ship in a fleet", level: 9 },
  // ── Level 10 (8-9 letters) ──
  { word: "algorithm", hint: "Step-by-step set of rules to solve a problem", level: 10 },
  { word: "jellyfish", hint: "Transparent ocean creature with tentacles", level: 10 },
  { word: "champagne", hint: "Sparkling wine from a region of France", level: 10 },
  { word: "chocolate", hint: "Sweet food made from cacao beans", level: 10 },
  { word: "parachute", hint: "Device used to slow a fall from the sky", level: 10 },
  { word: "clockwise", hint: "Turning in the same direction as clock hands", level: 10 },
  { word: "crocodile", hint: "Large reptile with powerful jaws living near water", level: 10 },
  { word: "blueprint", hint: "Technical drawing plan; a detailed design", level: 10 },
  { word: "magnitude", hint: "The size or extent of something", level: 10 },
  { word: "porcupine", hint: "Animal covered in sharp protective quills", level: 10 },
  // ── Level 11 (9-10 letters) ──
  { word: "caterpillar", hint: "Larva stage of a butterfly or moth", level: 11 },
  { word: "atmosphere", hint: "Layer of gases surrounding a planet", level: 11 },
  { word: "strawberry", hint: "Red summer fruit with seeds on the outside", level: 11 },
  { word: "rhinoceros", hint: "Large horned animal native to Africa and Asia", level: 11 },
  { word: "earthquake", hint: "Sudden shaking of the ground from tectonic movement", level: 11 },
  { word: "flashlight", hint: "Handheld battery-powered electric torch", level: 11 },
  { word: "thumbscrew", hint: "A type of fastening or historical torture device", level: 11 },
  { word: "motorcycle", hint: "Two-wheeled motor-powered vehicle", level: 11 },
  { word: "tablecloth", hint: "Fabric covering spread over a dining table", level: 11 },
  { word: "birthplace", hint: "Location where someone was born", level: 11 },
  // ── Level 12 (9-10 letters, trickier) ──
  { word: "bookkeeper", hint: "Person who records financial transactions", level: 12 },
  { word: "sunflower", hint: "Tall yellow flower that follows the sun", level: 12 },
  { word: "underwater", hint: "Below the surface of the water", level: 12 },
  { word: "skyscraper", hint: "Very tall modern building", level: 12 },
  { word: "chessboard", hint: "Checked board used to play chess", level: 12 },
  { word: "fingertip", hint: "The very end of a finger", level: 12 },
  { word: "wavelength", hint: "Distance between two wave peaks", level: 12 },
  { word: "catapult", hint: "Ancient siege weapon that hurls projectiles", level: 12 },
  { word: "submarine", hint: "A vessel that travels underwater", level: 12 },
  { word: "cartoonist", hint: "Artist who draws comic strips or animations", level: 12 },
  // ── Level 13 (10-11 letters) ──
  { word: "imagination", hint: "Ability to form mental images of new things", level: 13 },
  { word: "butterscotch", hint: "Toffee-like sweet made with butter and brown sugar", level: 13 },
  { word: "photography", hint: "Art of capturing images with a camera", level: 13 },
  { word: "electricity", hint: "Energy from charged particles powering our devices", level: 13 },
  { word: "constellation", hint: "Named pattern of stars in the night sky", level: 13 },
  { word: "kindergarten", hint: "First year of school before primary education", level: 13 },
  { word: "quarterback", hint: "Key offensive player in American football", level: 13 },
  { word: "microscope", hint: "Scientific instrument that magnifies tiny objects", level: 13 },
  { word: "celebration", hint: "Joyful event to mark a special occasion", level: 13 },
  { word: "archaeology", hint: "Study of history through excavated artefacts", level: 13 },
  // ── Level 14 (11-12 letters) ──
  { word: "architecture", hint: "Art and science of designing buildings", level: 14 },
  { word: "caterpillar", hint: "Larva that becomes a butterfly or moth", level: 14 },
  { word: "bibliography", hint: "List of sources cited in a written work", level: 14 },
  { word: "headquarters", hint: "Main office or centre of an organisation", level: 14 },
  { word: "subterranean", hint: "Existing or happening underground", level: 14 },
  { word: "thunderstorm", hint: "Storm with lightning and thunder", level: 14 },
  { word: "biochemistry", hint: "Study of chemical processes in living organisms", level: 14 },
  { word: "entrepreneur", hint: "Person who starts and runs their own business", level: 14 },
  { word: "rollercoaster", hint: "Thrilling fairground ride with steep drops", level: 14 },
  { word: "jurisdiction", hint: "Official power to make legal decisions", level: 14 },
  // ── Level 15 (11-13 letters) ──
  { word: "approximately", hint: "Almost but not exactly correct", level: 15 },
  { word: "extraordinary", hint: "Very unusual or remarkable", level: 15 },
  { word: "collaboration", hint: "Working together with others toward a shared goal", level: 15 },
  { word: "kaleidoscope", hint: "Tube toy that creates colourful symmetrical patterns", level: 15 },
  { word: "sustainability", hint: "Using resources in a way that can continue long-term", level: 15 },
  { word: "perpendicular", hint: "At a 90-degree angle to something else", level: 15 },
  { word: "mathematician", hint: "An expert in the field of mathematics", level: 15 },
  { word: "international", hint: "Involving more than one country", level: 15 },
  { word: "undergraduate", hint: "University student who hasn't yet earned their degree", level: 15 },
  { word: "abbreviation", hint: "Shortened form of a word or phrase", level: 15 },
  // ── Level 16 (12-13 letters) ──
  { word: "unfortunately", hint: "Used to express that something is unlucky or bad", level: 16 },
  { word: "communication", hint: "The exchange of information between people", level: 16 },
  { word: "characteristic", hint: "Typical feature or quality of something", level: 16 },
  { word: "uncomfortable", hint: "Causing a feeling of unease or discomfort", level: 16 },
  { word: "autobiography", hint: "Story of someone's life written by themselves", level: 16 },
  { word: "concentration", hint: "The ability to focus one's attention on something", level: 16 },
  { word: "sophisticated", hint: "Having refined knowledge; complex or developed", level: 16 },
  { word: "quarterfinalist", hint: "Person who reaches the final 8 of a competition", level: 16 },
  { word: "infrastructure", hint: "Basic physical systems of a country or organisation", level: 16 },
  { word: "hallucination", hint: "Experiencing something that is not really there", level: 16 },
  // ── Level 17 (13-14 letters) ──
  { word: "environmental", hint: "Relating to the natural world and its protection", level: 17 },
  { word: "choreographer", hint: "Person who designs and directs dance routines", level: 17 },
  { word: "comprehension", hint: "The ability to understand something fully", level: 17 },
  { word: "accommodation", hint: "A place to stay temporarily", level: 17 },
  { word: "indispensable", hint: "Absolutely necessary; impossible to do without", level: 17 },
  { word: "metamorphosis", hint: "Transformation, like a caterpillar becoming a butterfly", level: 17 },
  { word: "reincarnation", hint: "Belief that the soul is reborn in a new body", level: 17 },
  { word: "documentation", hint: "Written material that provides information", level: 17 },
  { word: "experimentation", hint: "The process of conducting scientific tests", level: 17 },
  { word: "paraphernalia", hint: "Equipment and accessories associated with an activity", level: 17 },
  // ── Level 18 (13-15 letters) ──
  { word: "Mediterranean", hint: "Sea surrounded by Europe, Africa, and Asia", level: 18 },
  { word: "photosynthesis", hint: "How plants make food using sunlight and CO2", level: 18 },
  { word: "representatives", hint: "People chosen to act or speak on behalf of others", level: 18 },
  { word: "interconnected", hint: "Linked or related to each other mutually", level: 18 },
  { word: "congratulations", hint: "Expression of praise for an achievement", level: 18 },
  { word: "misunderstanding", hint: "Failure to correctly interpret something", level: 18 },
  { word: "multidisciplinary", hint: "Combining several academic disciplines", level: 18 },
  { word: "acknowledgement", hint: "Recognition that something exists or is true", level: 18 },
  { word: "incomprehensible", hint: "Impossible to understand or comprehend", level: 18 },
  { word: "synchronisation", hint: "Coordinating things to happen at the same time", level: 18 },
  // ── Level 19 (15-16 letters, true challenges) ──
  { word: "straightforward", hint: "Uncomplicated, direct and easy to deal with", level: 19 },
  { word: "disproportionate", hint: "Too large or too small compared to something else", level: 19 },
  { word: "unquestionable", hint: "Not able to be doubted or challenged", level: 19 },
  { word: "autobiographical", hint: "Relating to the story of one's own life", level: 19 },
  { word: "oversimplification", hint: "Making something sound simpler than it really is", level: 19 },
  { word: "decentralisation", hint: "Transferring control from one central authority outward", level: 19 },
  { word: "procrastination", hint: "The habit of delaying tasks unnecessarily", level: 19 },
  { word: "counterproductive", hint: "Having the opposite of the intended result", level: 19 },
  { word: "neuroscientist", hint: "Scientist who studies the nervous system and brain", level: 19 },
  { word: "interdisciplinary", hint: "Involving several branches of knowledge or study", level: 19 },
  // ── Level 20 (expert — longest and rarest words) ──
  { word: "incomprehensibility", hint: "The quality of being impossible to understand", level: 20 },
  { word: "overrepresentation", hint: "Having a larger share than expected or deserved", level: 20 },
  { word: "misrepresentation", hint: "A false or inaccurate account of something", level: 20 },
  { word: "electroencephalogram", hint: "Brain wave test — records electrical brain activity", level: 20 },
  { word: "counterintuitive", hint: "Contrary to what you would naturally expect", level: 20 },
  { word: "compartmentalise", hint: "Divide into separate categories or sections mentally", level: 20 },
  { word: "characteristically", hint: "In a way that is typical of a person or thing", level: 20 },
  { word: "institutionalised", hint: "Established as a norm within a society or system", level: 20 },
  { word: "professionalisation", hint: "The process of making something more professional", level: 20 },
  { word: "superimposition", hint: "Placing one image or thing on top of another", level: 20 },
];
const MATH_LEVELS = {
  // ── LEVEL 1 – Simple addition & subtraction ──────────────────────────────
  1: [
    {q:"12 + 17 = ?", a:"29"}, {q:"34 + 25 = ?", a:"59"}, {q:"51 − 18 = ?", a:"33"},
    {q:"63 − 27 = ?", a:"36"}, {q:"45 + 38 = ?", a:"83"}, {q:"72 − 46 = ?", a:"26"},
    {q:"19 + 53 = ?", a:"72"}, {q:"88 − 35 = ?", a:"53"}, {q:"27 + 64 = ?", a:"91"},
    {q:"95 − 48 = ?", a:"47"}, {q:"33 + 49 = ?", a:"82"}, {q:"76 − 29 = ?", a:"47"},
    {q:"56 + 37 = ?", a:"93"}, {q:"82 − 54 = ?", a:"28"}, {q:"41 + 58 = ?", a:"99"},
    {q:"67 − 38 = ?", a:"29"}, {q:"24 + 76 = ?", a:"100"},{q:"100 − 63 = ?", a:"37"},
    {q:"55 + 46 = ?", a:"101"},{q:"91 − 44 = ?", a:"47"},
  ],
  // ── LEVEL 2 – Multiplication & simple division ───────────────────────────
  2: [
    {q:"7 × 8 = ?", a:"56"},  {q:"9 × 6 = ?", a:"54"},  {q:"12 × 7 = ?", a:"84"},
    {q:"8 × 11 = ?", a:"88"}, {q:"6 × 9 = ?", a:"54"},  {q:"13 × 5 = ?", a:"65"},
    {q:"72 ÷ 9 = ?", a:"8"},  {q:"84 ÷ 7 = ?", a:"12"}, {q:"96 ÷ 8 = ?", a:"12"},
    {q:"11 × 11 = ?", a:"121"},{q:"14 × 6 = ?", a:"84"},{q:"15 × 8 = ?", a:"120"},
    {q:"132 ÷ 11 = ?", a:"12"},{q:"9 × 13 = ?", a:"117"},{q:"144 ÷ 12 = ?", a:"12"},
    {q:"7 × 14 = ?", a:"98"}, {q:"168 ÷ 14 = ?", a:"12"},{q:"16 × 7 = ?", a:"112"},
    {q:"8 × 15 = ?", a:"120"},{q:"180 ÷ 15 = ?", a:"12"},
  ],
  // ── LEVEL 3 – Mixed arithmetic, order of operations ──────────────────────
  3: [
    {q:"3 + 4 × 5 = ?", a:"23", hint:"Multiplication before addition"},
    {q:"(6 + 4) × 3 = ?", a:"30"}, {q:"20 − 3 × 4 = ?", a:"8"},
    {q:"(15 − 5) ÷ 2 = ?", a:"5"}, {q:"2³ + 5 = ?", a:"13"},
    {q:"4² − 7 = ?", a:"9"},        {q:"(3 + 7)² = ?", a:"100"},
    {q:"50 ÷ (2 + 3) = ?", a:"10"},{q:"6 × 7 − 4² = ?", a:"26"},
    {q:"3 × (8 + 4) = ?", a:"36"}, {q:"5² − 3² = ?", a:"16"},
    {q:"(2 + 3) × (4 + 1) = ?", a:"25"}, {q:"7² − 40 = ?", a:"9"},
    {q:"(18 ÷ 3) + 4 × 2 = ?", a:"14"}, {q:"8 + 2 × (9 − 4) = ?", a:"18"},
    {q:"(5 + 3)² − 4 = ?", a:"60"},{q:"100 ÷ (5 × 4) = ?", a:"5"},
    {q:"3³ − 4 × 5 = ?", a:"7"},   {q:"(7 − 2)² + 1 = ?", a:"26"},
    {q:"6² ÷ (2 × 3) = ?", a:"6"},
  ],
  // ── LEVEL 4 – Fractions & decimals ──────────────────────────────────────
  4: [
    {q:"1/2 + 1/3 = ? (as fraction)", a:"5/6"}, {q:"3/4 − 1/4 = ?", a:"1/2"},
    {q:"2/3 × 3/4 = ?", a:"1/2"},               {q:"3/5 ÷ 3/10 = ?", a:"2"},
    {q:"1/4 + 3/8 = ?", a:"5/8"},               {q:"0.5 × 0.4 = ?", a:"0.2"},
    {q:"1.2 + 2.8 = ?", a:"4"},                  {q:"3.6 ÷ 0.9 = ?", a:"4"},
    {q:"5/6 − 1/3 = ?", a:"1/2"},               {q:"2/5 + 3/10 = ?", a:"7/10"},
    {q:"0.75 × 4 = ?", a:"3"},                   {q:"7/8 − 3/8 = ?", a:"1/2"},
    {q:"2.5 × 1.6 = ?", a:"4"},                  {q:"9/10 − 2/5 = ?", a:"1/2"},
    {q:"1/3 + 1/6 + 1/2 = ?", a:"1"},           {q:"3/4 × 8 = ?", a:"6"},
    {q:"1.5² = ?", a:"2.25"},                     {q:"4/7 + 3/7 = ?", a:"1"},
    {q:"0.125 × 8 = ?", a:"1"},                  {q:"5/8 + 3/8 = ?", a:"1"},
  ],
  // ── LEVEL 5 – Percentages & ratios ──────────────────────────────────────
  5: [
    {q:"20% of 150 = ?", a:"30"},   {q:"35% of 200 = ?", a:"70"},
    {q:"15% of 80 = ?", a:"12"},    {q:"What % is 45 of 180?", a:"25"},
    {q:"Increase 60 by 25% = ?", a:"75"}, {q:"Decrease 120 by 15% = ?", a:"102"},
    {q:"Ratio 3:5, total 40. Smaller part = ?", a:"15"},
    {q:"12:18 in simplest form = ?", a:"2:3"},
    {q:"40% of 250 = ?", a:"100"},  {q:"75% of 96 = ?", a:"72"},
    {q:"What % is 18 of 72?", a:"25"}, {q:"Increase 80 by 10% = ?", a:"88"},
    {q:"Decrease 200 by 30% = ?", a:"140"}, {q:"60% of 45 = ?", a:"27"},
    {q:"Ratio 2:3:5, total 100. Largest part = ?", a:"50"},
    {q:"What % is 13 of 52?", a:"25"}, {q:"1/5 as a % = ?", a:"20"},
    {q:"Increase 50 by 50% = ?", a:"75"}, {q:"3/8 as a % = ?", a:"37.5"},
    {q:"What % of 200 is 50?", a:"25"},
  ],
  // ── LEVEL 6 – Simple linear equations ───────────────────────────────────
  6: [
    {q:"x + 7 = 15. x = ?", a:"8"},   {q:"2x = 18. x = ?", a:"9"},
    {q:"x − 5 = 11. x = ?", a:"16"},  {q:"3x + 2 = 14. x = ?", a:"4"},
    {q:"4x − 3 = 13. x = ?", a:"4"},  {q:"5x = 45. x = ?", a:"9"},
    {q:"x/3 = 7. x = ?", a:"21"},     {q:"2x + 5 = 17. x = ?", a:"6"},
    {q:"7 − x = 2. x = ?", a:"5"},    {q:"3x − 9 = 0. x = ?", a:"3"},
    {q:"x/4 + 1 = 4. x = ?", a:"12"},{q:"6x = 42. x = ?", a:"7"},
    {q:"2x − 7 = 9. x = ?", a:"8"},   {q:"x + 13 = 21. x = ?", a:"8"},
    {q:"5x − 10 = 15. x = ?", a:"5"},{q:"x/2 − 3 = 1. x = ?", a:"8"},
    {q:"4x + 4 = 28. x = ?", a:"6"}, {q:"3x + 10 = 25. x = ?", a:"5"},
    {q:"9x = 72. x = ?", a:"8"},      {q:"2x/3 = 8. x = ?", a:"12"},
  ],
  // ── LEVEL 7 – Algebraic expressions & substitution ──────────────────────
  7: [
    {q:"If a=3, b=4: a² + b² = ?", a:"25"},
    {q:"If x=2: 3x² − x + 1 = ?", a:"11"},
    {q:"Expand: 3(x + 5) = ?", a:"3x + 15"},
    {q:"Simplify: 4x + 3x − 2x = ?", a:"5x"},
    {q:"If y=5: 2y² − 3y = ?", a:"35"},
    {q:"Expand: (x + 3)(x + 2) = ?", a:"x² + 5x + 6"},
    {q:"Factorise: x² + 7x + 12 = ?", a:"(x+3)(x+4)"},
    {q:"If m=−2: m² + 3m = ?", a:"−2"},
    {q:"Simplify: 6a − 2b + 3a + b = ?", a:"9a − b"},
    {q:"Expand: 2(3x − 4) = ?", a:"6x − 8"},
    {q:"If p=4, q=−1: p² − q = ?", a:"17"},
    {q:"Factorise: 2x² − 8x = ?", a:"2x(x − 4)"},
    {q:"Simplify: (3x²)(4x) = ?", a:"12x³"},
    {q:"If t=−3: t² + t + 1 = ?", a:"7"},
    {q:"Expand: (x − 5)(x + 5) = ?", a:"x² − 25"},
    {q:"Factorise: x² − 9 = ?", a:"(x−3)(x+3)"},
    {q:"If a=2, b=3: (a+b)² = ?", a:"25"},
    {q:"Simplify: 15x²y ÷ 5xy = ?", a:"3x"},
    {q:"Expand: (2x + 1)² = ?", a:"4x² + 4x + 1"},
    {q:"Factorise: x² − 5x + 6 = ?", a:"(x−2)(x−3)"},
  ],
  // ── LEVEL 8 – Simultaneous equations ────────────────────────────────────
  8: [
    {q:"x+y=10, x−y=4. x=?", a:"7"},
    {q:"2x+y=9, x+y=6. x=?", a:"3"},
    {q:"3x+2y=12, x=2. y=?", a:"3"},
    {q:"x+2y=8, 2x+y=7. x=?", a:"2"},
    {q:"4x−y=11, 2x+y=7. x=?", a:"3"},
    {q:"x+y=10, x−y=4. y=?", a:"3"},
    {q:"2x+3y=13, x+y=5. y=?", a:"3"},
    {q:"5x+2y=24, 3x+2y=16. x=?", a:"4"},
    {q:"x+3y=13, x−y=1. y=?", a:"3"},
    {q:"3x−y=10, x+y=6. x=?", a:"4"},
    {q:"2x+y=11, x−y=1. x+y sum=?", a:"8"},
    {q:"x+4y=17, x+y=8. y=?", a:"3"},
    {q:"6x+y=20, 4x+y=14. x=?", a:"3"},
    {q:"x+2y=10, 3x−2y=6. x=?", a:"4"},
    {q:"2x−y=5, x+y=7. x=?", a:"4"},
    {q:"3x+y=14, 2x−y=1. x=?", a:"3"},
    {q:"x+5y=21, x−y=3. y=?", a:"3"},
    {q:"4x+3y=23, 2x+3y=17. x=?", a:"3"},
    {q:"x+y=12, 2x−y=3. x=?", a:"5"},
    {q:"5x−2y=16, 3x−2y=8. x=?", a:"4"},
  ],
  // ── LEVEL 9 – Quadratic equations ───────────────────────────────────────
  9: [
    {q:"Solve x²−5x+6=0. Smaller root=?", a:"2"},
    {q:"Solve x²−7x+12=0. Larger root=?", a:"4"},
    {q:"Solve x²−9=0. Positive root=?", a:"3"},
    {q:"Solve x²+x−6=0. Positive root=?", a:"2"},
    {q:"Solve x²−4x−5=0. Larger root=?", a:"5"},
    {q:"Solve x²−6x+9=0. x=?", a:"3"},
    {q:"Solve x²−25=0. Positive root=?", a:"5"},
    {q:"Solve x²+2x−8=0. Larger root=?", a:"2"},
    {q:"Solve x²−3x=0. Non-zero root=?", a:"3"},
    {q:"Solve 2x²−8=0. Positive root=?", a:"2"},
    {q:"Sum of roots of x²−5x+6=0?", a:"5"},
    {q:"Product of roots of x²−7x+12=0?", a:"12"},
    {q:"Solve x²+5x+6=0. Larger root=?", a:"−2"},
    {q:"Solve x²−8x+15=0. Smaller root=?", a:"3"},
    {q:"Discriminant of x²−4x+4=0?", a:"0"},
    {q:"Solve x²−16=0. Sum of roots=?", a:"0"},
    {q:"Solve x²−10x+24=0. Larger root=?", a:"6"},
    {q:"Solve x²+x−12=0. Positive root=?", a:"3"},
    {q:"Solve 3x²−12=0. Positive root=?", a:"2"},
    {q:"Solve x²−x−2=0. Larger root=?", a:"2"},
  ],
  // ── LEVEL 10 – Inequalities & number properties ──────────────────────────
  10: [
    {q:"Solve 2x + 3 > 11. x > ?", a:"4"},
    {q:"Solve 3x − 5 ≤ 10. x ≤ ?", a:"5"},
    {q:"Solve 4x < 20. x < ?", a:"5"},
    {q:"Smallest integer satisfying 2x > 9?", a:"5"},
    {q:"Solve −2x > 8. x < ?", a:"−4"},
    {q:"Is 2 a solution of 3x − 1 > 4?", a:"No"},
    {q:"LCM of 12 and 18?", a:"36"},
    {q:"HCF of 24 and 36?", a:"12"},
    {q:"How many prime numbers below 20?", a:"8"},
    {q:"Is 97 prime?", a:"Yes"},
    {q:"LCM of 8 and 12?", a:"24"},
    {q:"HCF of 48 and 72?", a:"24"},
    {q:"Sum of first 10 odd numbers?", a:"100"},
    {q:"Is 1 a prime number?", a:"No"},
    {q:"LCM of 6, 8, 12?", a:"24"},
    {q:"How many factors does 36 have?", a:"9"},
    {q:"Solve |x| = 5. Positive solution=?", a:"5"},
    {q:"Solve 5 − 2x ≥ 1. x ≤ ?", a:"2"},
    {q:"HCF of 36 and 48?", a:"12"},
    {q:"Smallest prime > 20?", a:"23"},
  ],
  // ── LEVEL 11 – Geometry: angles & triangles ──────────────────────────────
  11: [
    {q:"Sum of interior angles of a triangle = ?°", a:"180"},
    {q:"A right angle = ?°", a:"90"},
    {q:"Supplementary angle of 65° = ?°", a:"115"},
    {q:"Complementary angle of 38° = ?°", a:"52"},
    {q:"Exterior angle of equilateral triangle = ?°", a:"120"},
    {q:"Sum of interior angles of a quadrilateral = ?°", a:"360"},
    {q:"In △ABC, A=50°, B=70°. C=?°", a:"60"},
    {q:"Each interior angle of regular hexagon = ?°", a:"120"},
    {q:"Sum of exterior angles of any polygon = ?°", a:"360"},
    {q:"Each interior angle of regular pentagon = ?°", a:"108"},
    {q:"Vertically opposite angles are: equal or supplementary?", a:"equal"},
    {q:"In isosceles △, base angles each 70°. Apex angle = ?°", a:"40"},
    {q:"An angle of 135° is called: acute/obtuse/reflex?", a:"obtuse"},
    {q:"Each angle of a regular octagon = ?°", a:"135"},
    {q:"Interior angle sum of pentagon = ?°", a:"540"},
    {q:"Co-interior angles sum = ?°", a:"180"},
    {q:"Alternate interior angles are: equal or supplementary?", a:"equal"},
    {q:"In △, two angles are 45° each. Third = ?°", a:"90"},
    {q:"Exterior angle of regular 9-gon = ?°", a:"40"},
    {q:"Interior angle sum of hexagon = ?°", a:"720"},
  ],
  // ── LEVEL 12 – Area & perimeter ──────────────────────────────────────────
  12: [
    {q:"Area of rectangle 8×5 = ?", a:"40"},
    {q:"Perimeter of square side 7 = ?", a:"28"},
    {q:"Area of triangle base 10 height 6 = ?", a:"30"},
    {q:"Area of circle radius 7 (use π=22/7) = ?", a:"154"},
    {q:"Circumference of circle r=7 (π=22/7) = ?", a:"44"},
    {q:"Area of parallelogram base 9 height 4 = ?", a:"36"},
    {q:"Area of trapezium parallel sides 6&10 height 4 = ?", a:"32"},
    {q:"Perimeter of rectangle 12×5 = ?", a:"34"},
    {q:"Area of rhombus diagonals 8&6 = ?", a:"24"},
    {q:"Area of equilateral triangle side 4 (use √3≈1.73) ≈ ?", a:"6.93"},
    {q:"Perimeter of equilateral triangle side 9 = ?", a:"27"},
    {q:"Area of circle diameter 14 (π=22/7) = ?", a:"154"},
    {q:"Area of square diagonal 10√2. Side=?", a:"10"},
    {q:"Perimeter of triangle sides 5,12,13 = ?", a:"30"},
    {q:"Area of sector angle 90° r=7 (π=22/7) = ?", a:"38.5"},
    {q:"Area of rectangle perimeter 30, length 10. Width=?", a:"5"},
    {q:"Curved surface area of cylinder r=7 h=10 (π=22/7) = ?", a:"440"},
    {q:"Area of right △ legs 6 and 8 = ?", a:"24"},
    {q:"Length of arc angle 60° r=6 (π=22/7) ≈ ?", a:"6.28"},
    {q:"Area of square side 11 = ?", a:"121"},
  ],
  // ── LEVEL 13 – Pythagoras & coordinate geometry ──────────────────────────
  13: [
    {q:"Right △ legs 3,4. Hypotenuse = ?", a:"5"},
    {q:"Right △ legs 5,12. Hypotenuse = ?", a:"13"},
    {q:"Hypotenuse 10, one leg 6. Other leg = ?", a:"8"},
    {q:"Hypotenuse 13, one leg 5. Other leg = ?", a:"12"},
    {q:"Right △ legs 8,15. Hypotenuse = ?", a:"17"},
    {q:"Distance between (0,0) and (3,4) = ?", a:"5"},
    {q:"Distance between (1,1) and (4,5) = ?", a:"5"},
    {q:"Midpoint of (2,4) and (6,8) = ?", a:"(4,6)"},
    {q:"Slope of line through (0,0) and (4,8) = ?", a:"2"},
    {q:"y-intercept of y = 3x − 5 = ?", a:"−5"},
    {q:"Slope of line y = −2x + 7 = ?", a:"−2"},
    {q:"Midpoint of (−2,3) and (6,7) = ?", a:"(2,5)"},
    {q:"Distance between (−3,0) and (0,4) = ?", a:"5"},
    {q:"Slope of line through (2,1) and (5,7) = ?", a:"2"},
    {q:"x-intercept of y = 2x − 6 = ?", a:"3"},
    {q:"Right △ hyp 25, one leg 7. Other leg = ?", a:"24"},
    {q:"Distance between (1,2) and (4,6) = ?", a:"5"},
    {q:"Midpoint of (3,−1) and (7,5) = ?", a:"(5,2)"},
    {q:"Slope of x-axis = ?", a:"0"},
    {q:"Equation of line slope 2, y-int 3: y=?", a:"y=2x+3"},
  ],
  // ── LEVEL 14 – Trigonometry basics ──────────────────────────────────────
  14: [
    {q:"sin 30° = ?", a:"0.5"},         {q:"cos 60° = ?", a:"0.5"},
    {q:"tan 45° = ?", a:"1"},           {q:"sin 90° = ?", a:"1"},
    {q:"cos 0° = ?", a:"1"},            {q:"sin 60° = ? (√3/2 acceptable)", a:"√3/2"},
    {q:"cos 30° = ? (√3/2 acceptable)", a:"√3/2"}, {q:"tan 60° = ?", a:"√3"},
    {q:"sin²30° + cos²30° = ?", a:"1"},{q:"In right △, opposite=3, hyp=5. sin θ=?", a:"3/5"},
    {q:"In right △, adj=4, hyp=5. cos θ=?", a:"4/5"},
    {q:"In right △, opp=3, adj=4. tan θ=?", a:"3/4"},
    {q:"sin 0° = ?", a:"0"},            {q:"cos 90° = ?", a:"0"},
    {q:"tan 0° = ?", a:"0"},
    {q:"2sin30°cos30° = ? (use sin60°)", a:"√3/2"},
    {q:"sin²45° = ?", a:"0.5"},         {q:"cos²45° = ?", a:"0.5"},
    {q:"1 + tan²45° = ?", a:"2"},       {q:"sec 60° = ? (1/cos60°)", a:"2"},
  ],
  // ── LEVEL 15 – Progressions & series ────────────────────────────────────
  15: [
    {q:"AP: 3,7,11,... 10th term=?", a:"39"},
    {q:"GP: 2,6,18,... 4th term=?", a:"54"},
    {q:"AP sum first 10 terms, a=1 d=2?", a:"100"},
    {q:"GP: 3,6,12,... 5th term=?", a:"48"},
    {q:"AP: 5,8,11,... which term is 32?", a:"10"},
    {q:"Sum of first 20 natural numbers?", a:"210"},
    {q:"Sum of first n natural numbers formula: n(n+1)/2. n=15: sum=?", a:"120"},
    {q:"AP first term 2, last term 20, n=10. Sum=?", a:"110"},
    {q:"GP ratio r=3, first term 2, 3rd term=?", a:"18"},
    {q:"AP: 100,95,90,... How many terms to reach 0?", a:"21"},
    {q:"Sum of squares 1²+2²+3²+...+5² = ?", a:"55"},
    {q:"GP 1,2,4,8... Sum of first 8 terms=?", a:"255"},
    {q:"AP: 7,11,15,... 20th term=?", a:"83"},
    {q:"Common difference of AP: 3,7,11,15... = ?", a:"4"},
    {q:"Common ratio of GP: 4,8,16,... = ?", a:"2"},
    {q:"Sum of first 100 natural numbers=?", a:"5050"},
    {q:"AP: −3,1,5,... 15th term=?", a:"53"},
    {q:"How many terms in AP 5,8,...,59?", a:"19"},
    {q:"GP 5, ratio 1/5. 3rd term=?", a:"0.2"},
    {q:"Sum of first 5 terms GP a=1 r=2?", a:"31"},
  ],
  // ── LEVEL 16 – Functions & graphs ───────────────────────────────────────
  16: [
    {q:"f(x)=2x+3. f(5)=?", a:"13"},
    {q:"f(x)=x²−1. f(3)=?", a:"8"},
    {q:"Domain of f(x)=1/x excludes?", a:"0"},
    {q:"f(x)=√x. f(16)=?", a:"4"},
    {q:"f(x)=x²+2x+1. f(−1)=?", a:"0"},
    {q:"If f(x)=3x−2, find x when f(x)=10.", a:"4"},
    {q:"f(x)=x³. f(−2)=?", a:"−8"},
    {q:"Range of f(x)=x² is?", a:"y≥0"},
    {q:"f(x)=|x|. f(−7)=?", a:"7"},
    {q:"f(x)=2^x. f(3)=?", a:"8"},
    {q:"If f(x)=x+5 and g(x)=2x, f(g(3))=?", a:"11"},
    {q:"Inverse of f(x)=2x+1 is f⁻¹(x)=?", a:"(x−1)/2"},
    {q:"f(x)=x²−4x. f(2)=?", a:"−4"},
    {q:"f(x)=log₂(x). f(8)=?", a:"3"},
    {q:"f(g(x)) where f(x)=x² g(x)=x+1. f(g(2))=?", a:"9"},
    {q:"f(x)=5x−3. f⁻¹(7)=?", a:"2"},
    {q:"Is f(x)=x² one-to-one? Yes or No", a:"No"},
    {q:"f(x)=3x. f(0)=?", a:"0"},
    {q:"f(x)=2x²+1. f(−3)=?", a:"19"},
    {q:"f(x)=(x+2)(x−3). zeros at x=?", a:"−2,3"},
  ],
  // ── LEVEL 17 – Logarithms & exponentials ────────────────────────────────
  17: [
    {q:"log₂(8) = ?", a:"3"},              {q:"log₁₀(1000) = ?", a:"3"},
    {q:"log₃(81) = ?", a:"4"},             {q:"log₂(32) = ?", a:"5"},
    {q:"ln(e²) = ?", a:"2"},               {q:"log₁₀(0.01) = ?", a:"−2"},
    {q:"log₅(125) = ?", a:"3"},            {q:"log₂(1) = ?", a:"0"},
    {q:"2^x = 16. x = ?", a:"4"},          {q:"3^x = 27. x = ?", a:"3"},
    {q:"log₁₀(10) = ?", a:"1"},            {q:"log₂(64) = ?", a:"6"},
    {q:"5^x = 25. x = ?", a:"2"},          {q:"log₄(16) = ?", a:"2"},
    {q:"log₂(16)+log₂(2) = ?", a:"5"},
    {q:"log(ab) = log a + ?", a:"log b"},
    {q:"log(a/b) = log a − ?", a:"log b"},
    {q:"logₙ(n) = ?", a:"1"},              {q:"4^x = 256. x = ?", a:"4"},
    {q:"log₃(3^5) = ?", a:"5"},
  ],
  // ── LEVEL 18 – Limits (intro calculus) ──────────────────────────────────
  18: [
    {q:"lim x→2 (x²) = ?", a:"4"},
    {q:"lim x→0 (x+3) = ?", a:"3"},
    {q:"lim x→3 (x²−9)/(x−3) = ?", a:"6", hint:"Factorise numerator"},
    {q:"lim x→∞ (1/x) = ?", a:"0"},
    {q:"lim x→0 (sin x/x) = ?", a:"1"},
    {q:"lim x→2 (2x²−8)/(x−2) = ?", a:"8"},
    {q:"lim x→1 (x²−1)/(x−1) = ?", a:"2"},
    {q:"lim x→∞ (3/x²) = ?", a:"0"},
    {q:"lim x→4 (x−4)/√(x−2) = ?", a:"4"},
    {q:"lim x→0 (3x/x) = ?", a:"3"},
    {q:"lim x→5 (x²−25)/(x−5) = ?", a:"10"},
    {q:"lim x→∞ (5x+2)/(x+1) = ?", a:"5"},
    {q:"lim x→2 (x³−8)/(x−2) = ?", a:"12"},
    {q:"lim x→0⁺ (ln x) = ?", a:"−∞"},
    {q:"lim x→∞ (n²+n)/n² = ?", a:"1"},
    {q:"lim x→2 3 = ?", a:"3"},
    {q:"lim x→0 (tan x / x) = ?", a:"1"},
    {q:"lim x→1 (x³−1)/(x−1) = ?", a:"3"},
    {q:"lim x→∞ (2x²)/(3x²+1) = ?", a:"2/3"},
    {q:"lim x→0 (e^x−1)/x = ?", a:"1"},
  ],
  // ── LEVEL 19 – Basic derivatives ────────────────────────────────────────
  19: [
    {q:"d/dx (x³) = ?", a:"3x²"},          {q:"d/dx (x⁵) = ?", a:"5x⁴"},
    {q:"d/dx (7x) = ?", a:"7"},             {q:"d/dx (x²+3x) = ?", a:"2x+3"},
    {q:"d/dx (sin x) = ?", a:"cos x"},      {q:"d/dx (cos x) = ?", a:"−sin x"},
    {q:"d/dx (eˣ) = ?", a:"eˣ"},            {q:"d/dx (ln x) = ?", a:"1/x"},
    {q:"d/dx (x^n) = ?", a:"nx^(n−1)"},
    {q:"d/dx (5) = ?", a:"0"},              {q:"d/dx (√x) = ?", a:"1/(2√x)"},
    {q:"d/dx (tan x) = ?", a:"sec²x"},
    {q:"d/dx (3x² + 2x) at x=1 = ?", a:"8"},
    {q:"d/dx (x⁴ − 3x²) = ?", a:"4x³ − 6x"},
    {q:"d/dx (e^(2x)) = ?", a:"2e^(2x)"},
    {q:"d/dx (sin 2x) = ?", a:"2cos 2x"},
    {q:"d/dx (1/x) = ?", a:"−1/x²"},
    {q:"d/dx (x² · eˣ) at x=0 = ?", a:"0"},
    {q:"d/dx (3x³) = ?", a:"9x²"},
    {q:"f(x)=x²−4x. f'(3)=?", a:"2"},
  ],
  // ── LEVEL 20 – Basic integrals ───────────────────────────────────────────
  20: [
    {q:"∫ x dx = ?", a:"x²/2 + C"},        {q:"∫ x² dx = ?", a:"x³/3 + C"},
    {q:"∫ 1 dx = ?", a:"x + C"},           {q:"∫ eˣ dx = ?", a:"eˣ + C"},
    {q:"∫ sin x dx = ?", a:"−cos x + C"}, {q:"∫ cos x dx = ?", a:"sin x + C"},
    {q:"∫ 1/x dx = ?", a:"ln|x| + C"},
    {q:"∫₀² x dx = ?", a:"2"},
    {q:"∫ 2x dx = ?", a:"x² + C"},         {q:"∫ 3x² dx = ?", a:"x³ + C"},
    {q:"∫₀¹ x² dx = ?", a:"1/3"},          {q:"∫₁² 2x dx = ?", a:"3"},
    {q:"∫ x^n dx = ?", a:"x^(n+1)/(n+1) + C"},
    {q:"∫ sec²x dx = ?", a:"tan x + C"},
    {q:"∫₀^π sin x dx = ?", a:"2"},
    {q:"∫ e^(2x) dx = ?", a:"e^(2x)/2 + C"},
    {q:"Area under f(x)=2 from x=0 to x=5 = ?", a:"10"},
    {q:"∫₀¹ (x+1) dx = ?", a:"3/2"},
    {q:"∫ (x+1)² dx expanded first: ∫(x²+2x+1)dx = ?", a:"x³/3+x²+x+C"},
    {q:"∫₁³ 3 dx = ?", a:"6"},
  ],
  // ── LEVEL 21 – 3D geometry & volume ─────────────────────────────────────
  21: [
    {q:"Volume of cube side 5 = ?", a:"125"},
    {q:"Surface area of cube side 4 = ?", a:"96"},
    {q:"Volume of cuboid 5×4×3 = ?", a:"60"},
    {q:"Volume of cylinder r=7 h=10 (π=22/7) = ?", a:"1540"},
    {q:"Volume of sphere r=3 (use 4/3 π r³, π≈3.14) ≈ ?", a:"113.1"},
    {q:"Total surface area cylinder r=7 h=5 (π=22/7) = ?", a:"528"},
    {q:"Volume of cone r=3 h=4 (1/3πr²h, π≈3.14) ≈ ?", a:"37.7"},
    {q:"Diagonal of cuboid 3×4×12 = ?", a:"13"},
    {q:"Volume of prism base area 20 h=6 = ?", a:"120"},
    {q:"Slant height of cone r=3 h=4 = ?", a:"5"},
    {q:"Surface area of sphere r=7 (4πr², π=22/7) = ?", a:"616"},
    {q:"Volume of pyramid base 9 h=6 = ?", a:"18"},
    {q:"How many faces does a tetrahedron have?", a:"4"},
    {q:"Diagonal of cube side 3 = ? (3√3 ≈ 5.19)", a:"5.19"},
    {q:"Volume of hollow cube outer 5 inner 3 = ?", a:"98"},
    {q:"Total surface area of hemisphere r=7 (3πr²) (π=22/7) = ?", a:"462"},
    {q:"How many edges does a cube have?", a:"12"},
    {q:"Volume of frustum: use (πh/3)(R²+r²+Rr). h=3,R=4,r=2 ≈?", a:"87.96"},
    {q:"CSA of cone r=5, l=13 (πrl, π=22/7) = ?", a:"204.2"},
    {q:"Lateral surface area of cube side 6 = ?", a:"144"},
  ],
  // ── LEVEL 22 – Combinatorics & probability ───────────────────────────────
  22: [
    {q:"5! = ?", a:"120"},                  {q:"6! = ?", a:"720"},
    {q:"P(5,2) = 5!/(5-2)! = ?", a:"20"}, {q:"C(5,2) = ?", a:"10"},
    {q:"C(6,3) = ?", a:"20"},              {q:"C(10,1) = ?", a:"10"},
    {q:"P(4,4) = ?", a:"24"},
    {q:"Probability of rolling a 6 on fair die = ?", a:"1/6"},
    {q:"Probability of flipping heads on fair coin = ?", a:"1/2"},
    {q:"2 dice: P(sum=7) = ?", a:"1/6"},
    {q:"Cards: P(ace from 52) = ?", a:"1/13"},
    {q:"P(A or B) = P(A)+P(B)−P(A∩B). If P(A)=0.4 P(B)=0.3 P(A∩B)=0.1: P(A∪B)=?", a:"0.6"},
    {q:"Complementary probability: P(A')=1−P(A). P(A)=0.7: P(A')=?", a:"0.3"},
    {q:"C(7,3) = ?", a:"35"},
    {q:"In how many ways arrange 3 books from 6?", a:"120"},
    {q:"Probability both coins heads (2 fair coins) = ?", a:"1/4"},
    {q:"C(8,2) = ?", a:"28"},
    {q:"P(drawing red from 3 red 2 blue) = ?", a:"3/5"},
    {q:"Binomial coefficient C(n,0) = ?", a:"1"},
    {q:"P(no heads in 3 tosses) = ?", a:"1/8"},
  ],
  // ── LEVEL 23 – Statistics & data ────────────────────────────────────────
  23: [
    {q:"Mean of 4,7,9,10,5 = ?", a:"7"},
    {q:"Median of 3,7,2,9,5 = ?", a:"5"},
    {q:"Mode of 2,3,3,4,4,4,5 = ?", a:"4"},
    {q:"Range of 14,7,21,3,18 = ?", a:"18"},
    {q:"Mean of 10,20,30,40,50 = ?", a:"30"},
    {q:"Variance of 2,4,6: mean=4. Var=?", a:"2.67"},
    {q:"Std dev of 2,4,6 (use var≈2.67) ≈ ?", a:"1.63"},
    {q:"Median of 1,3,5,7,9,11 = ?", a:"6"},
    {q:"If mean of 5 numbers is 8, their sum = ?", a:"40"},
    {q:"Mean deviation of 1,2,3,4,5 from mean = ?", a:"1.2"},
    {q:"P(z<0) in standard normal = ?", a:"0.5"},
    {q:"Which measure is affected most by outliers: mean/median/mode?", a:"mean"},
    {q:"Correlation coefficient range: ? to ?", a:"−1 to 1"},
    {q:"Class mark of class 20−30 = ?", a:"25"},
    {q:"Ogive is used to find?", a:"median"},
    {q:"Mean of first 5 natural numbers = ?", a:"3"},
    {q:"Weighted mean: values 10,20 weights 3,7. WM=?", a:"17"},
    {q:"Median of 11,12,13,14,15,16 = ?", a:"13.5"},
    {q:"If all data values equal, std dev = ?", a:"0"},
    {q:"Mode of 5,5,5,5 = ?", a:"5"},
  ],
  // ── LEVEL 24 – Set theory & logic ───────────────────────────────────────
  24: [
    {q:"A={1,2,3} B={2,3,4}. A∪B = ?", a:"{1,2,3,4}"},
    {q:"A={1,2,3} B={2,3,4}. A∩B = ?", a:"{2,3}"},
    {q:"n(A∪B) = n(A)+n(B)−n(A∩B). n(A)=5 n(B)=4 n(A∩B)=2. n(A∪B)=?", a:"7"},
    {q:"A'= complement. If U={1..5} A={1,3,5}. A'=?", a:"{2,4}"},
    {q:"A−B where A={1,2,3,4} B={2,4} = ?", a:"{1,3}"},
    {q:"Symmetric difference: A△B where A={1,2} B={2,3}=?", a:"{1,3}"},
    {q:"Power set of {a,b} has how many elements?", a:"4"},
    {q:"Is the empty set ⊆ every set?", a:"Yes"},
    {q:"A×B where A={1} B={a,b}: |A×B|=?", a:"2"},
    {q:"De Morgan: (A∪B)' = A' ∩ ?", a:"B'"},
    {q:"If P then Q. P is true, Q must be?", a:"True"},
    {q:"NOT (NOT P) = ?", a:"P"},
    {q:"P AND NOT P = ?", a:"False"},
    {q:"P OR NOT P = ?", a:"True"},
    {q:"Contrapositive of 'if P then Q' is?", a:"if not Q then not P"},
    {q:"Number of subsets of set {1,2,3} = ?", a:"8"},
    {q:"If A⊆B and B⊆A then A=?", a:"B"},
    {q:"P(A|B) = P(A∩B)/P(B). If P(A∩B)=0.2 P(B)=0.5: P(A|B)=?", a:"0.4"},
    {q:"Number of proper subsets of {a,b,c} = ?", a:"7"},
    {q:"A∩∅ = ?", a:"∅"},
  ],
  // ── LEVEL 25 – Advanced algebra & polynomials ───────────────────────────
  25: [
    {q:"Remainder when x³−2x+1 divided by (x−1) = ?", a:"0"},
    {q:"Is (x−1) a factor of x³−1?", a:"Yes"},
    {q:"Sum of roots of 2x²−6x+4=0 = ?", a:"3"},
    {q:"Product of roots of 3x²−9x+6=0 = ?", a:"2"},
    {q:"If α+β=5 αβ=6, α²+β²=?", a:"13"},
    {q:"Roots of x²−3x+2=0 are?", a:"1 and 2"},
    {q:"Degree of polynomial 3x⁴−2x²+7 = ?", a:"4"},
    {q:"If x=2 is root of x²+bx−6=0, b=?", a:"1"},
    {q:"Factor theorem: f(a)=0 means (x−a) is a?", a:"factor"},
    {q:"Expand (x+y)³ = ?", a:"x³+3x²y+3xy²+y³"},
    {q:"Coefficient of x² in (x+3)³ = ?", a:"9"},
    {q:"(a+b)²−(a−b)² = ?", a:"4ab"},
    {q:"Sum of roots x²−px+q=0 = ?", a:"p"},
    {q:"If roots are 3 and 5, the equation is x²−?x+15=0", a:"8"},
    {q:"Remainder when x²+5x+6 divided by (x+2) = ?", a:"0"},
    {q:"(a−b)³ = a³−3a²b+3ab²−?", a:"b³"},
    {q:"Product of roots x²+5x+6=0 = ?", a:"6"},
    {q:"Discriminant of 2x²−4x+2=0 = ?", a:"0"},
    {q:"How many real roots when discriminant < 0?", a:"0"},
    {q:"If α,β roots of x²−7x+10=0: α³+β³ = (α+β)³−3αβ(α+β) = ?", a:"133"},
  ],
  // ── LEVEL 26 – Matrices & determinants ──────────────────────────────────
  26: [
    {q:"det [[2,3],[1,4]] = ?", a:"5"},
    {q:"det [[5,0],[0,5]] = ?", a:"25"},
    {q:"[[1,2],[3,4]] + [[5,6],[7,8]] = first element of result?", a:"6"},
    {q:"Trace of [[3,1],[2,5]] = ?", a:"8"},
    {q:"det [[1,0],[0,1]] = ?", a:"1"},
    {q:"2×[[1,2],[3,4]] = element (1,2) of result?", a:"4"},
    {q:"[[1,2],[0,1]]×[[1,0],[0,1]] = trace = ?", a:"2"},
    {q:"Rank of zero matrix = ?", a:"0"},
    {q:"[[2,1],[1,3]]×[[1],[0]] = first element?", a:"2"},
    {q:"If det(A)=0, matrix A is called?", a:"singular"},
    {q:"Inverse of [[2,0],[0,3]]: element (1,1) = ?", a:"0.5"},
    {q:"det [[a,b],[c,d]] = ad − ?", a:"bc"},
    {q:"Order of product (2×3)×(3×4) matrix = ?", a:"2×4"},
    {q:"Transpose of [[1,2],[3,4]]: element (1,2) = ?", a:"3"},
    {q:"Eigenvalue of identity matrix = ?", a:"1"},
    {q:"det [[3,1],[2,4]] = ?", a:"10"},
    {q:"[[1,0],[0,1]] is called the?", a:"identity matrix"},
    {q:"Row reduce: is [[1,2],[2,4]] invertible?", a:"No"},
    {q:"Product of diagonal elements [[3,0],[0,4]] = ?", a:"12"},
    {q:"Cofactor of element (1,1) of [[2,3],[1,4]] = ?", a:"4"},
  ],
  // ── LEVEL 27 – Complex numbers ───────────────────────────────────────────
  27: [
    {q:"i² = ?", a:"−1"},                   {q:"i³ = ?", a:"−i"},
    {q:"i⁴ = ?", a:"1"},                    {q:"(2+3i)+(1−i) = ?", a:"3+2i"},
    {q:"(3+2i)(1+i) = ?", a:"1+5i"},        {q:"|3+4i| = ?", a:"5"},
    {q:"Conjugate of (4−3i) = ?", a:"4+3i"},
    {q:"(2+i)(2−i) = ?", a:"5"},
    {q:"i^100 = ?", a:"1"},                  {q:"i^(4k) = ? for any integer k", a:"1"},
    {q:"Real part of (5+7i) = ?", a:"5"},    {q:"Imaginary part of (3−4i) = ?", a:"−4"},
    {q:"(1+i)² = ?", a:"2i"},               {q:"|1+i| = ?", a:"√2"},
    {q:"Argument of pure positive real number = ?°", a:"0"},
    {q:"(3+4i)/(1+0i) real part = ?", a:"3"},
    {q:"1/i = ?", a:"−i"},
    {q:"Sum of cube roots of unity = ?", a:"0"},
    {q:"Product of (a+bi)(a−bi) = ?", a:"a²+b²"},
    {q:"Polar form: r(cosθ+i sinθ). For 1+i, r=?", a:"√2"},
  ],
  // ── LEVEL 28 – Vectors & basic mechanics ────────────────────────────────
  28: [
    {q:"Magnitude of vector (3,4) = ?", a:"5"},
    {q:"Dot product (1,2)·(3,4) = ?", a:"11"},
    {q:"Unit vector of (3,4) = ?", a:"(3/5,4/5)"},
    {q:"(2,3)+(4,−1) = ?", a:"(6,2)"},
    {q:"Cross product of i×j = ?", a:"k"},
    {q:"Dot product of perpendicular vectors = ?", a:"0"},
    {q:"3(2,4) = ?", a:"(6,12)"},
    {q:"Angle between (1,0) and (0,1) = ?°", a:"90"},
    {q:"Projection of a on b = (a·b)/|b|. a=(3,4) b=(0,1): proj=?", a:"4"},
    {q:"If A=(1,2,3) B=(4,2,0): AB vector = ?", a:"(3,0,−3)"},
    {q:"Position vector of midpoint A=(2,4) B=(6,8) = ?", a:"(4,6)"},
    {q:"i·i = ?", a:"1"},
    {q:"Speed = distance/time. d=100km t=2h: speed=?", a:"50"},
    {q:"Acceleration = change in velocity/time. Δv=20 t=4: a=?", a:"5"},
    {q:"F=ma. m=5kg a=3m/s². F=?", a:"15 N"},
    {q:"Work = F×d. F=10N d=5m: W=?", a:"50 J"},
    {q:"KE = ½mv². m=2 v=3: KE=?", a:"9 J"},
    {q:"PE = mgh. m=5 g=10 h=4: PE=?", a:"200 J"},
    {q:"Power = Work/Time. W=200J t=4s: P=?", a:"50 W"},
    {q:"Magnitude of (6,8) = ?", a:"10"},
  ],
  // ── LEVEL 29 – Calculus: chain rule & applications ───────────────────────
  29: [
    {q:"d/dx sin(3x) = ?", a:"3cos(3x)"},
    {q:"d/dx (x²+1)³ = ?", a:"6x(x²+1)²"},
    {q:"d/dx e^(3x) = ?", a:"3e^(3x)"},
    {q:"d/dx ln(x²) = ?", a:"2/x"},
    {q:"d/dx (sin x)² = ?", a:"2sin x cos x"},
    {q:"d/dx (2x+1)⁵ = ?", a:"10(2x+1)⁴"},
    {q:"Critical points of f(x)=x³−3x: f'(x)=0 at x=?", a:"±1"},
    {q:"f''(x) of f(x)=x⁴ = ?", a:"12x²"},
    {q:"d/dx tan(2x) = ?", a:"2sec²(2x)"},
    {q:"If f'(x)=0 and f''(x)>0, it is a?", a:"local minimum"},
    {q:"d/dx x·sin x = ?", a:"sin x + x cos x"},
    {q:"d/dx (eˣ·x) = ?", a:"eˣ(x+1)"},
    {q:"Slope of tangent to y=x² at x=3 = ?", a:"6"},
    {q:"d/dx cos²x = ?", a:"−2cos x sin x"},
    {q:"d/dx 1/(x+1) = ?", a:"−1/(x+1)²"},
    {q:"f(x)=x³−6x². Inflection x=?", a:"2"},
    {q:"d/dx √(3x+1) = ?", a:"3/(2√(3x+1))"},
    {q:"d/dx (sin x / x) at x→0 behaviour: limit=?", a:"1"},
    {q:"d/dx arctan(x) = ?", a:"1/(1+x²)"},
    {q:"d/dx (x² ln x) = ?", a:"x(2ln x+1)"},
  ],
  // ── LEVEL 30 – Integration techniques ───────────────────────────────────
  30: [
    {q:"∫ sin(2x) dx = ?", a:"−cos(2x)/2 + C"},
    {q:"∫ e^(3x) dx = ?", a:"e^(3x)/3 + C"},
    {q:"∫ 1/(x+1) dx = ?", a:"ln|x+1| + C"},
    {q:"∫ cos(5x) dx = ?", a:"sin(5x)/5 + C"},
    {q:"∫ x·eˣ dx = ?", a:"eˣ(x−1) + C"},
    {q:"∫ x·sin x dx = ?", a:"sin x − x cos x + C"},
    {q:"∫₀^(π/2) sin x dx = ?", a:"1"},
    {q:"∫ sec²(3x) dx = ?", a:"tan(3x)/3 + C"},
    {q:"∫ 2x/(x²+1) dx = ?", a:"ln(x²+1) + C"},
    {q:"∫₀¹ x·eˣ dx = ?", a:"1"},
    {q:"∫ sin²x dx using identity = ?", a:"x/2 − sin(2x)/4 + C"},
    {q:"∫ 1/√(1−x²) dx = ?", a:"arcsin x + C"},
    {q:"∫ x³ dx from 0 to 2 = ?", a:"4"},
    {q:"∫ (2x+3)⁴ dx = ?", a:"(2x+3)⁵/10 + C"},
    {q:"∫ ln x dx = ?", a:"x ln x − x + C"},
    {q:"∫ tan x dx = ?", a:"−ln|cos x| + C"},
    {q:"∫₀² (3x²+1) dx = ?", a:"10"},
    {q:"∫ cos²x dx = ?", a:"x/2 + sin(2x)/4 + C"},
    {q:"By parts: ∫ x² eˣ dx leading term = ?", a:"x²eˣ−2xeˣ+2eˣ+C"},
    {q:"∫₁ᵉ 1/x dx = ?", a:"1"},
  ],
  // ── LEVEL 31 – Profit/Loss & percentages (QUANT) – 2 min ─────────────────
  31: [
    {q:"CP=200, SP=250. Profit % = ?", a:"25"},
    {q:"CP=500, SP=400. Loss % = ?", a:"20"},
    {q:"Profit 20%, CP=150. SP = ?", a:"180"},
    {q:"Loss 15%, CP=800. SP = ?", a:"680"},
    {q:"SP=330, profit 10%. CP = ?", a:"300"},
    {q:"SP=680, loss 15%. CP = ?", a:"800"},
    {q:"Marked price 400, discount 20%. SP = ?", a:"320"},
    {q:"Two articles CP 200 each: 1st sold 20% profit, 2nd 20% loss. Net = ?", a:"No profit no loss"},
    {q:"SP=600, profit=100. Profit % = ?", a:"20"},
    {q:"If CP=x, SP=1.3x. Profit = ?", a:"30%"},
    {q:"After 2 successive 10% discounts on 1000, final price = ?", a:"810"},
    {q:"CP 400 loss 25%. SP = ?", a:"300"},
    {q:"Profit % if CP=80 SP=100 = ?", a:"25"},
    {q:"A shopkeeper uses 800g weight for 1kg. Profit % = ?", a:"25"},
    {q:"If MP=500 SP=400 discount = ?", a:"20%"},
    {q:"Profit is 1/4 of CP. Profit % = ?", a:"25"},
    {q:"CP=750 profit 1/3 of CP. SP=?", a:"1000"},
    {q:"After 30% rise then 30% fall: net % = ?", a:"−9%"},
    {q:"Three items CP 150 each sold at profit 10,20,30%. Average profit%=?", a:"20"},
    {q:"Trade discount 25% on 800. Invoice price = ?", a:"600"},
  ],
  // ── LEVEL 32 – Time, Work & Pipes (QUANT) – 2 min ───────────────────────
  32: [
    {q:"A does work in 10 days, B in 15. Together in ? days", a:"6"},
    {q:"Pipe A fills in 4h, B in 6h. Together in ? hours", a:"2.4"},
    {q:"A can finish in 12 days. In 4 days he does ? fraction", a:"1/3"},
    {q:"A&B together 6 days. A alone 10 days. B alone?", a:"15"},
    {q:"Pipe fills in 8h, leaks empties in 12h. Together fill in ? h", a:"24"},
    {q:"A=8 days, B=12 days, C=24 days. Together in?", a:"4"},
    {q:"20 workers build in 30 days. 15 workers in?", a:"40"},
    {q:"If 6 men earn 900 in 5 days, daily per man = ?", a:"30"},
    {q:"Efficiency ratio A:B=3:2. B alone 30 days. A alone=?", a:"20"},
    {q:"3 pipes fill: 6h, 8h, 12h. Together fill in?", a:"2.67h"},
    {q:"A finishes 1/3 work in 3 days. Total days=?", a:"9"},
    {q:"Work done by A and B in first 2 days if together do it in 6 days = ?", a:"1/3"},
    {q:"A is twice as fast as B. A does it in 6 days. B=?", a:"12"},
    {q:"If 1 man 1 day = 1 unit, 10 men 10 days = ? units", a:"100"},
    {q:"A+B finish in 8 days. A alone 12. B's fraction per day=?", a:"1/24"},
    {q:"Inlet pipe fills in 20 min, outlet drains in 30 min. Net fill time=?", a:"60 min"},
    {q:"A takes 20% less time than B. B=25 days. A=?", a:"20"},
    {q:"Work ratio A:B=2:3. Together 30 units. A does?", a:"12"},
    {q:"If half work done by 5 people in 4 days, full work 10 people in?", a:"4"},
    {q:"A alone 18, B alone 9. Days to finish together=?", a:"6"},
  ],
  // ── LEVEL 33 – Speed, Distance & Time (QUANT) – 2 min ───────────────────
  33: [
    {q:"Distance 240km, time 4h. Speed = ?", a:"60 km/h"},
    {q:"Speed 60, time 2.5h. Distance = ?", a:"150 km"},
    {q:"120km at 40, then 120km at 60. Avg speed = ?", a:"48 km/h"},
    {q:"Train 120m long at 72km/h. Time to cross pole = ?", a:"6 sec"},
    {q:"Two trains 100m & 80m, speeds 36 & 54 km/h opposite. Time to cross = ?", a:"8 sec"},
    {q:"Train 200m at 54km/h crosses platform 200m. Time = ?", a:"26.67 sec"},
    {q:"Relative speed same direction: 60 and 40 km/h. Relative = ?", a:"20 km/h"},
    {q:"A to B in 6h, B to A in 4h. Avg speed for round trip = ?", a:"4.8 × (distance/5)"},
    {q:"Speed 54km/h in m/s = ?", a:"15 m/s"},
    {q:"15 m/s in km/h = ?", a:"54 km/h"},
    {q:"Walking 3km/h reach late by 15min. At 5km/h on time. Distance=?", a:"1.875 km"},
    {q:"Boat speed 8km/h, current 2km/h. Upstream speed=?", a:"6 km/h"},
    {q:"Downstream 10km/h, upstream 6km/h. Boat speed in still water=?", a:"8 km/h"},
    {q:"Man rows 18km in 3h downstream. Current 2km/h. Rowing speed=?", a:"4 km/h"},
    {q:"Train 150m crosses bridge 350m at 50m/s. Time=?", a:"10 sec"},
    {q:"Cyclist covers 800m in 1 min 20 sec. Speed in m/s=?", a:"10 m/s"},
    {q:"Two trains 400km apart approach: 60 & 40 km/h. Meet after?", a:"4 h"},
    {q:"Sound travels 340m/s. Echo from wall 170m away heard after?", a:"1 sec"},
    {q:"Car covers 1/3 at 30, 1/3 at 60, 1/3 at 90. Avg speed≈?", a:"49.09 km/h"},
    {q:"If speed halved, time for same distance?", a:"doubled"},
  ],
  // ── LEVEL 34 – Mixtures, Alligation & Interest (QUANT) – 2 min ──────────
  34: [
    {q:"SI: P=1000 R=5% T=3yr. SI=?", a:"150"},
    {q:"CI: P=1000 R=10% T=2yr. CI=?", a:"210"},
    {q:"Amount after CI: P=5000 R=20% T=2yr = ?", a:"7200"},
    {q:"SI: P=2000 R=8% T=2.5yr. Total amount=?", a:"2400"},
    {q:"At what rate SI doubles in 10yr?", a:"10%"},
    {q:"Alligation: milk at 20/L, water at 0. Mixture sells at 15/L. Ratio milk:water=?", a:"3:1"},
    {q:"Two solutions 30% and 60% acid mixed equally. Resultant % = ?", a:"45"},
    {q:"Vessel 40L, 10L removed and replaced with water thrice. Milk left=?", a:"16.875 L"},
    {q:"A can 40%: B can 20%. Mix 1:3. Result % = ?", a:"25"},
    {q:"CI for 2 years at 10% on 5000 = ?", a:"1050"},
    {q:"P=10000 doubles in 5yr (CI). Rate % ≈ ? (use 2^0.2≈1.149)", a:"14.87%"},
    {q:"SI in 4yr = CI in 2yr at 10%. P ratio = ?", a:"P same formula verify: SI=0.4P CI=0.21P"},
    {q:"Wine-water: 25L, 5L wine removed filled water. Wine left = ?", a:"20 L"},
    {q:"Profit = SI on CP for 1yr at 20%. Equivalent gain % = ?", a:"20"},
    {q:"If CI for 2yr at r% is ₹210 on ₹1000, r=?", a:"10"},
    {q:"Alligation: cheap at 10, dear at 25, mean 20. Ratio cheap:dear=?", a:"1:2"},
    {q:"Water added to 100mL 30% solution to make 20%: water added=?", a:"50 mL"},
    {q:"Find P if SI=300 R=5% T=4yr", a:"1500"},
    {q:"A=P(1+R/100)^T. P=4000 R=5 T=2. A=?", a:"4410"},
    {q:"Time to triple at 20% SI = ?", a:"10 yr"},
  ],
  // ── LEVEL 35 – Number puzzles & advanced quant (QUANT) – 2 min ──────────
  35: [
    {q:"A number is 4 more than 3× its digits sum. If it's a 2-digit number with digit sum 7, and tens digit+2=units digit. Number=?", a:"25"},
    {q:"Two numbers ratio 3:5, LCM=75. Numbers=?", a:"15 and 25"},
    {q:"Three consecutive odd numbers sum=75. Middle=?", a:"25"},
    {q:"A fraction: num+2/denom+2=3/4 and num/denom=2/3. Num=?", a:"4"},
    {q:"Digit sum of 2^10 = 1024. Digit sum=?", a:"7"},
    {q:"Difference of squares: 25²−24²=?", a:"49"},
    {q:"Product of 3 consecutive numbers is 120. Middle number=?", a:"5"},
    {q:"Find x: 2^(x+1)=32", a:"4"},
    {q:"How many zeros at end of 100! ?", a:"24"},
    {q:"Sum of all 2-digit multiples of 9 = ?", a:"495"},
    {q:"A 3-digit number abc: a+b+c=15, a=b+1=c+2. Number=?", a:"654"},
    {q:"5^15 ÷ 5^12 = ?", a:"125"},
    {q:"Last digit of 7^100 = ?", a:"1"},
    {q:"If 2x ≡ 1 (mod 3), x ≡ ?", a:"2"},
    {q:"Sum of prime factors of 60 = ?", a:"10"},
    {q:"How many 3-digit palindromes are there?", a:"90"},
    {q:"LCM × HCF = product of 2 numbers. LCM=36 HCF=4 one number=12. Other=?", a:"12"},
    {q:"x+y=10, xy=21. x²+y²=?", a:"58"},
    {q:"Remainder of 17^23 mod 10 = ?", a:"7"},
    {q:"If |3x−7|=2, values of x = ?", a:"3 or 5/3"},
  ],
  // ── LEVEL 36 – Advanced probability & expected value – 2 min ────────────
  36: [
    {q:"E[X]: X=1,2,3 with P=1/3 each. E[X]=?", a:"2"},
    {q:"Binomial P(X=2): n=5 p=0.4. P=C(5,2)(0.4)²(0.6)³≈?", a:"0.3456"},
    {q:"Poisson P(X=0): λ=2. P=e^−2≈?", a:"0.135"},
    {q:"P(A∩B)=0.12, P(A)=0.4. P(B|A)=?", a:"0.3"},
    {q:"Variance of Binomial(n=10,p=0.5) = ?", a:"2.5"},
    {q:"Normal dist: P(Z<1.96)≈?", a:"0.975"},
    {q:"Var(3X) where Var(X)=4 = ?", a:"36"},
    {q:"E[2X+3] where E[X]=5 = ?", a:"13"},
    {q:"Bayes: P(A|B) = P(B|A)P(A)/P(B). If P(B|A)=0.8 P(A)=0.3 P(B)=0.4: P(A|B)=?", a:"0.6"},
    {q:"Standard deviation of Binomial(n=100 p=0.5) = ?", a:"5"},
    {q:"Geometric distribution mean: E[X]=1/p. p=0.25: E[X]=?", a:"4"},
    {q:"P(X>1) if X~Poisson(λ=1) = 1−P(0)−P(1) ≈ ?", a:"0.264"},
    {q:"Two dice: P(sum=8) = ?", a:"5/36"},
    {q:"Cards: P(two aces in 2 draws without replacement) = ?", a:"1/221"},
    {q:"If X uniform[0,4], P(1<X<3) = ?", a:"0.5"},
    {q:"Mean of uniform distribution [a,b] = (a+b)/2. [2,8]: mean=?", a:"5"},
    {q:"Variance of uniform[0,12] = (b−a)²/12 = ?", a:"12"},
    {q:"Chebyshev: P(|X−μ|≥2σ) ≤ ?", a:"1/4"},
    {q:"P(A) =0.6, independent P(B)=0.5. P(A and B)=?", a:"0.3"},
    {q:"Median of geometric distribution? Not a closed form — is it larger than mean?", a:"Yes"},
  ],
  // ── LEVEL 37 – Game theory & decision maths – 2 min ──────────────────────
  37: [
    {q:"Minimax strategy: Player minimises maximum loss. True or False?", a:"True"},
    {q:"Nash equilibrium: neither player benefits from changing strategy unilaterally. T/F?", a:"True"},
    {q:"Payoff matrix: dominant strategy chosen regardless of opponent. T/F?", a:"True"},
    {q:"Zero-sum game: one player's gain = other's loss. T/F?", a:"True"},
    {q:"Prisoner's dilemma: both defect is a Nash equilibrium. T/F?", a:"True"},
    {q:"Saddle point value of [[3,5],[2,4]] (minimax) = ?", a:"3"},
    {q:"Expected value of lottery: 1000 with p=0.01, 0 otherwise. EV=?", a:"10"},
    {q:"Risk-neutral person chooses by: EV, utility or variance?", a:"EV"},
    {q:"Dominated strategy should be?", a:"eliminated"},
    {q:"In a 2×2 game, max number of pure Nash equilibria = ?", a:"4"},
    {q:"Cooperative game: players form coalitions. T/F?", a:"True"},
    {q:"Shapley value distributes coalition surplus fairly. T/F?", a:"True"},
    {q:"PERT critical path: longest or shortest path?", a:"longest"},
    {q:"Linear programming feasible region is called a?", a:"convex polytope"},
    {q:"Simplex method solves LP by moving between?", a:"vertices"},
    {q:"Objective function at optimal LP solution is at?", a:"corner point"},
    {q:"Transportation problem minimises?", a:"cost"},
    {q:"Assignment problem: Hungarian method finds?", a:"minimum cost"},
    {q:"Network flow: max-flow min-cut theorem: max flow = ?", a:"min cut"},
    {q:"Decision tree: chance node represented by?", a:"circle"},
  ],
  // ── LEVEL 38 – Advanced calculus applications – 2 min ────────────────────
  38: [
    {q:"Volume of revolution of y=√x from 0 to 4 about x-axis = π∫₀⁴x dx = ?", a:"8π"},
    {q:"Arc length of y=x from 0 to 1 = ∫₀¹√(1+1)dx = ?", a:"√2"},
    {q:"d²y/dx² of y=sin x at x=0 = ?", a:"0"},
    {q:"Taylor series of eˣ first 3 terms at x=0 = ?", a:"1+x+x²/2"},
    {q:"Maclaurin series sin x first 2 terms = ?", a:"x − x³/6"},
    {q:"∫₋₁¹ x³ dx = ?", a:"0"},
    {q:"Partial derivative ∂/∂x (x²y) = ?", a:"2xy"},
    {q:"Partial derivative ∂/∂y (x²y+y²) = ?", a:"x²+2y"},
    {q:"Gradient ∇f where f=x²+y²: ∇f = ?", a:"(2x,2y)"},
    {q:"Jacobian of (x²,xy) w.r.t (x,y) determinant = ?", a:"x²"},
    {q:"Euler's method: y'=y y(0)=1 h=0.1. y(0.1)≈?", a:"1.1"},
    {q:"Laplace transform L{1} = ?", a:"1/s"},
    {q:"L{eˢᵗ} = ?", a:"1/(s−a)"},
    {q:"Fourier series: periodic function represented as sum of?", a:"sines and cosines"},
    {q:"Green's theorem relates line integral to?", a:"double integral"},
    {q:"Stokes' theorem: ∮F·dr = ∬(∇×F)·dS. True/False?", a:"True"},
    {q:"Divergence theorem: volume integral of ∇·F = surface integral. T/F?", a:"True"},
    {q:"d/dx ∫₀ˣ sin t dt = ?", a:"sin x"},
    {q:"Second fundamental theorem of calculus says d/dx ∫ₐˣ f(t)dt = ?", a:"f(x)"},
    {q:"L'Hôpital: lim x→0 (sin x/x). Apply to get = ?", a:"1"},
  ],
  // ── LEVEL 39 – Number theory & abstract algebra – 2 min ──────────────────
  39: [
    {q:"Euler's totient φ(10) = ?", a:"4"},
    {q:"φ(p) for prime p = ?", a:"p−1"},
    {q:"Fermat's little theorem: a^(p−1) ≡ ? (mod p) for prime p, a not multiple of p", a:"1"},
    {q:"gcd(48,18) by Euclidean algorithm = ?", a:"6"},
    {q:"Is Z₆ under addition a group?", a:"Yes"},
    {q:"Order of element 2 in Z₆ (additive) = ?", a:"3"},
    {q:"A group of prime order is?", a:"cyclic"},
    {q:"Z under addition: identity element = ?", a:"0"},
    {q:"Inverse of 3 in Z₇ (multiplicative) = ?", a:"5"},
    {q:"Chinese Remainder: x≡1(mod2) x≡2(mod3). x≡?(mod6)", a:"5"},
    {q:"Number of generators of Z₁₂ = φ(12) = ?", a:"4"},
    {q:"Is the set of even integers a subgroup of Z?", a:"Yes"},
    {q:"A ring has both + and × with + forming?", a:"abelian group"},
    {q:"Degree of splitting field of x²−2 over Q = ?", a:"2"},
    {q:"Is Q[√2] a field?", a:"Yes"},
    {q:"Wilson's theorem: (p−1)! ≡ ? (mod p)", a:"−1"},
    {q:"Quadratic residue: is 3 a QR mod 7? (check 3^((7-1)/2) mod 7 = 1?)", a:"Yes"},
    {q:"Legendre symbol (a/p)=0 if p|a. (7/7)=?", a:"0"},
    {q:"Primitive root mod 7: does 3 generate all non-zero residues mod 7?", a:"Yes"},
    {q:"Sum of all residues mod 5: 0+1+2+3+4=?", a:"10"},
  ],
  // ── LEVEL 40 – Mixed hard quant & olympiad style – 2 min ──────────────────
  40: [
    {q:"If x+1/x=3, x²+1/x²=?", a:"7"},
    {q:"If a+b+c=1 a²+b²+c²=1, ab+bc+ca=?", a:"0"},
    {q:"Solve: 2^x + 2^(−x) = 2.5. x=? (try x=1 or x=−1)", a:"±1"},
    {q:"In a GP, 3rd term=4, 7th term=64. Common ratio=?", a:"2"},
    {q:"Sum to infinity GP: a=12, r=1/3. S=?", a:"18"},
    {q:"A clock shows 3:00. Angle between hands = ?°", a:"90"},
    {q:"At 4:20, angle between clock hands = ?°", a:"10"},
    {q:"Number of diagonals of decagon (10-gon) = ?", a:"35"},
    {q:"If log₂x + log₄x = 3, x = ?", a:"8"},
    {q:"Remainder of (2^30 + 3) mod 5 = ?", a:"4"},
    {q:"Number of solutions to x²+y²=25 in positive integers = ?", a:"2"},
    {q:"If 3^x=4^y, x/y=?", a:"log4/log3"},
    {q:"Largest prime factor of 2310 = ?", a:"11"},
    {q:"Sum of infinite series 1+2/3+4/9+8/27+... = ?", a:"3"},
    {q:"How many 4-digit numbers are divisible by 15?", a:"600"},
    {q:"If |x−3|+|x+3|=8, x in interval = ?", a:"[−4,4]"},
    {q:"AM−GM: a=4,b=9. AM=? GM=?", a:"6.5 and 6"},
    {q:"Roots of z²+z+1=0 are cube roots of unity (ω,ω²). ω³=?", a:"1"},
    {q:"Find the number of ways to choose a committee of 3 from 10 where 2 specific people must be included.", a:"8"},
    {q:"If f(x+y)=f(x)+f(y) and f(1)=3, f(7)=?", a:"21"},
  ],
};



function getLevelConfig(lvl) {
  let timer;
  if      (lvl <= 5)  timer = 30;
  else if (lvl <= 15) timer = 25;
  else if (lvl <= 30) timer = 22;
  else                timer = 120;
  const labels = {
    1:"Simple Addition & Subtraction",2:"Multiplication & Division",3:"Order of Operations",4:"Fractions & Decimals",5:"Percentages & Ratios",
    6:"Linear Equations",7:"Algebraic Expressions",8:"Simultaneous Equations",9:"Quadratic Equations",10:"Inequalities & Number Theory",
    11:"Geometry — Angles & Triangles",12:"Area & Perimeter",13:"Pythagoras & Coordinates",14:"Trigonometry Basics",15:"Progressions & Series",
    16:"Functions & Graphs",17:"Logarithms & Exponentials",18:"Limits",19:"Derivatives",20:"Integrals",
    21:"3D Geometry & Volume",22:"Combinatorics & Probability",23:"Statistics & Data",24:"Set Theory & Logic",25:"Advanced Algebra & Polynomials",
    26:"Matrices & Determinants",27:"Complex Numbers",28:"Vectors & Mechanics",29:"Chain Rule & Calculus Applications",30:"Integration Techniques",
    31:"⏱ Profit & Loss (2 min)",32:"⏱ Time & Work (2 min)",33:"⏱ Speed, Distance & Time (2 min)",34:"⏱ Mixtures & Interest (2 min)",
    35:"⏱ Number Puzzles (2 min)",36:"⏱ Probability & Statistics (2 min)",37:"⏱ Decision Maths (2 min)",38:"⏱ Advanced Calculus (2 min)",
    39:"⏱ Number Theory & Algebra (2 min)",40:"⏱ Mixed Olympiad Style (2 min)",
  };
  return { label: labels[lvl] || `Level ${lvl}`, timer };
}

const TRIVIA_QUESTIONS = [

  // ================= SCIENCE (1–25) =================
  { q: "What planet is known as the Red Planet?", opts: ["Venus","Mars","Jupiter"], ans: 1, cat:"🔬 Science" },
  { q: "What gas do plants absorb from the air?", opts: ["Oxygen","Nitrogen","Carbon dioxide"], ans: 2, cat:"🔬 Science" },
  { q: "How many bones are in the adult human body?", opts: ["206","186","256"], ans: 0, cat:"🔬 Science" },
  { q: "What is the chemical symbol for gold?", opts: ["Go","Au","Ag"], ans: 1, cat:"🔬 Science" },
  { q: "Which planet has the most moons?", opts: ["Saturn","Jupiter","Neptune"], ans: 0, cat:"🔬 Science" },
  { q: "Which particle has a negative charge?", opts: ["Proton","Electron","Neutron"], ans: 1, cat:"🔬 Science" },
  { q: "What is the SI unit of force?", opts: ["Joule","Pascal","Newton"], ans: 2, cat:"🔬 Science" },
  { q: "Which vitamin is synthesized from sunlight?", opts: ["Vitamin A","Vitamin D","Vitamin B12"], ans: 1, cat:"🔬 Science" },
  { q: "What part of brain controls balance?", opts: ["Cerebrum","Cerebellum","Medulla"], ans: 1, cat:"🔬 Science" },
  { q: "Speed of light is approx?", opts: ["3×10^8 m/s","3×10^6 m/s","3×10^5 m/s"], ans: 0, cat:"🔬 Science" },
  { q: "Atomic number of Carbon?", opts: ["6","8","12"], ans: 0, cat:"🔬 Science" },
  { q: "Which gas is most abundant in atmosphere?", opts: ["Oxygen","Nitrogen","Carbon dioxide"], ans: 1, cat:"🔬 Science" },
  { q: "Unit of electric resistance?", opts: ["Volt","Ohm","Ampere"], ans: 1, cat:"🔬 Science" },
  { q: "Which organ produces insulin?", opts: ["Liver","Pancreas","Kidney"], ans: 1, cat:"🔬 Science" },
  { q: "DNA shape is?", opts: ["Single helix","Double helix","Triple helix"], ans: 1, cat:"🔬 Science" },
  { q: "Which blood cells fight infection?", opts: ["RBC","WBC","Platelets"], ans: 1, cat:"🔬 Science" },
  { q: "Boiling point of water?", opts: ["100°C","90°C","80°C"], ans: 0, cat:"🔬 Science" },
  { q: "Which planet is closest to Sun?", opts: ["Mercury","Venus","Earth"], ans: 0, cat:"🔬 Science" },
  { q: "Which vitamin helps clotting?", opts: ["Vitamin K","Vitamin C","Vitamin D"], ans: 0, cat:"🔬 Science" },
  { q: "Which metal is liquid at room temp?", opts: ["Mercury","Iron","Copper"], ans: 0, cat:"🔬 Science" },
  { q: "SI unit of power?", opts: ["Watt","Joule","Newton"], ans: 0, cat:"🔬 Science" },
  { q: "What is study of fungi called?", opts: ["Botany","Mycology","Zoology"], ans: 1, cat:"🔬 Science" },
  { q: "Which vitamin deficiency causes scurvy?", opts: ["C","D","A"], ans: 0, cat:"🔬 Science" },
  { q: "Which planet has rings?", opts: ["Saturn","Mars","Venus"], ans: 0, cat:"🔬 Science" },
  { q: "Which organ detoxifies body?", opts: ["Kidney","Liver","Heart"], ans: 1, cat:"🔬 Science" },

  // ================= INDIA GK (26–50) =================
  { q: "Longest river in India?", opts: ["Ganga","Godavari","Brahmaputra"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Highest civilian award?", opts: ["Padma Shri","Padma Bhushan","Bharat Ratna"], ans: 2, cat:"🇮🇳 India GK" },
  { q: "First Indian Nobel laureate?", opts: ["Tagore","Raman","Sen"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Largest state by area?", opts: ["MP","Rajasthan","UP"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "Highest mountain peak in India?", opts: ["K2","Kanchenjunga","Nanda Devi"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Indian national aquatic animal?", opts: ["Dolphin","Shark","Whale"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which state has longest coastline?", opts: ["Gujarat","TN","AP"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "First satellite of India?", opts: ["INSAT","Aryabhata","Bhaskara"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "Currency symbol of India?", opts: ["₹","$","£"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which city is financial capital?", opts: ["Delhi","Mumbai","Chennai"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "National tree?", opts: ["Neem","Banyan","Peepal"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "First woman PM?", opts: ["Indira Gandhi","Pratibha Patil","Sarojini"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "National river?", opts: ["Ganga","Yamuna","Godavari"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "ISRO HQ?", opts: ["Bangalore","Hyderabad","Delhi"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which state produces most tea?", opts: ["Assam","WB","Kerala"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Who founded Maurya Empire?", opts: ["Ashoka","Chandragupta","Bindusara"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "First President?", opts: ["Rajendra Prasad","Radhakrishnan","Zakir"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "National song?", opts: ["Vande Mataram","Jana Gana Mana","Sare Jahan"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "India became republic in?", opts: ["1950","1947","1952"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "First IIT?", opts: ["Kharagpur","Bombay","Delhi"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "First metro city?", opts: ["Delhi","Kolkata","Mumbai"], ans: 1, cat:"🇮🇳 India GK" },
  { q: "Largest dam?", opts: ["Bhakra","Tehri","Hirakud"], ans: 2, cat:"🇮🇳 India GK" },
  { q: "Which state highest literacy?", opts: ["Kerala","TN","Goa"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "First Indian in space?", opts: ["Rakesh Sharma","Kalpana","Sunita"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which state shares most borders?", opts: ["UP","MP","Rajasthan"], ans: 0, cat:"🇮🇳 India GK" },

  // ================= POLITICS (51–70) =================
  { q: "Indian constitution adopted in?", opts: ["1949","1950","1947"], ans: 0, cat:"🏛 Politics" },
  { q: "Minimum age President?", opts: ["30","35","40"], ans: 1, cat:"🏛 Politics" },
  { q: "Lok Sabha max strength?", opts: ["545","550","540"], ans: 0, cat:"🏛 Politics" },
  { q: "Who appoints governors?", opts: ["PM","President","CJ"], ans: 1, cat:"🏛 Politics" },
  { q: "Fundamental duties added in?", opts: ["1976","1950","1980"], ans: 0, cat:"🏛 Politics" },
  { q: "Rajya Sabha permanent?", opts: ["Yes","No","Partially"], ans: 0, cat:"🏛 Politics" },
  { q: "Emergency declared under?", opts: ["352","356","360"], ans: 0, cat:"🏛 Politics" },
  { q: "First general election year?", opts: ["1951","1947","1955"], ans: 0, cat:"🏛 Politics" },
  { q: "Head of judiciary?", opts: ["President","CJI","PM"], ans: 1, cat:"🏛 Politics" },
  { q: "Election Commission type?", opts: ["Constitutional","Statutory","Executive"], ans: 0, cat:"🏛 Politics" },
  { q: "Finance Commission article?", opts: ["280","270","300"], ans: 0, cat:"🏛 Politics" },
  { q: "First woman president?", opts: ["Patil","Indira","Sarojini"], ans: 0, cat:"🏛 Politics" },
  { q: "Union budget presented by?", opts: ["FM","PM","President"], ans: 0, cat:"🏛 Politics" },
  { q: "Parliament joint sitting called by?", opts: ["President","PM","Speaker"], ans: 0, cat:"🏛 Politics" },
  { q: "Lok Sabha term?", opts: ["5","6","4"], ans: 0, cat:"🏛 Politics" },
  { q: "Rajya Sabha max members?", opts: ["250","245","260"], ans: 1, cat:"🏛 Politics" },
  { q: "Who signs bills?", opts: ["President","PM","Speaker"], ans: 0, cat:"🏛 Politics" },
  { q: "Which schedule has languages?", opts: ["8th","7th","9th"], ans: 0, cat:"🏛 Politics" },
  { q: "Which body removes judges?", opts: ["Parliament","President","SC"], ans: 0, cat:"🏛 Politics" },
  { q: "First amendment year?", opts: ["1951","1950","1955"], ans: 0, cat:"🏛 Politics" },

  // ================= CRICKET (71–90) =================
  { q: "Most ODI runs?", opts: ["Sachin","Kohli","Ponting"], ans: 0, cat:"🏏 Cricket" },
  { q: "Most Test runs?", opts: ["Sachin","Cook","Ponting"], ans: 0, cat:"🏏 Cricket" },
  { q: "First T20 WC winner?", opts: ["India","Pak","Aus"], ans: 0, cat:"🏏 Cricket" },
  { q: "Highest individual ODI score?", opts: ["264","237","250"], ans: 0, cat:"🏏 Cricket" },
  { q: "Most WC wins?", opts: ["Aus","Ind","WI"], ans: 0, cat:"🏏 Cricket" },
  { q: "100 centuries player?", opts: ["Sachin","Kohli","Ponting"], ans: 0, cat:"🏏 Cricket" },
  { q: "First double ton ODI?", opts: ["Sachin","Sehwag","Rohit"], ans: 0, cat:"🏏 Cricket" },
  { q: "Captain 1983?", opts: ["Kapil","Gavaskar","Vengsarkar"], ans: 0, cat:"🏏 Cricket" },
  { q: "IPL started?", opts: ["2008","2010","2005"], ans: 0, cat:"🏏 Cricket" },
  { q: "Most IPL titles team?", opts: ["MI","CSK","KKR"], ans: 0, cat:"🏏 Cricket" },
  { q: "Fastest ball record?", opts: ["Akhtar","Lee","Starc"], ans: 0, cat:"🏏 Cricket" },
  { q: "Most Test wickets?", opts: ["Muralitharan","Warne","Kumble"], ans: 0, cat:"🏏 Cricket" },
  { q: "First WC year?", opts: ["1975","1979","1983"], ans: 0, cat:"🏏 Cricket" },
  { q: "Max runs in over?", opts: ["36","30","28"], ans: 0, cat:"🏏 Cricket" },
  { q: "First IPL winner?", opts: ["RR","MI","CSK"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which country hosted 2011 WC final?", opts: ["India","SL","Ban"], ans: 0, cat:"🏏 Cricket" },
  { q: "Who hit 6 sixes in over?", opts: ["Yuvraj","Gayle","Pollard"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which format lasts 5 days?", opts: ["Test","ODI","T20"], ans: 0, cat:"🏏 Cricket" },
  { q: "Most IPL runs?", opts: ["Kohli","Dhawan","Rohit"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which trophy India vs Aus?", opts: ["Border-Gavaskar","Ashes","Pataudi"], ans: 0, cat:"🏏 Cricket" },

  // ================= GEOGRAPHY (91–110) =================
  { q: "Largest ocean?", opts: ["Pacific","Atlantic","Indian"], ans: 0, cat:"🌍 Geography" },
  { q: "Highest peak world?", opts: ["Everest","K2","Kangchen"], ans: 0, cat:"🌍 Geography" },
  { q: "Largest continent?", opts: ["Asia","Africa","Europe"], ans: 0, cat:"🌍 Geography" },
  { q: "Smallest country?", opts: ["Vatican","Monaco","Nauru"], ans: 0, cat:"🌍 Geography" },
  { q: "Longest river world?", opts: ["Nile","Amazon","Yangtze"], ans: 0, cat:"🌍 Geography" },
  { q: "Largest desert?", opts: ["Sahara","Gobi","Arabian"], ans: 0, cat:"🌍 Geography" },
  { q: "Capital of Canada?", opts: ["Ottawa","Toronto","Montreal"], ans: 0, cat:"🌍 Geography" },
  { q: "Capital of Brazil?", opts: ["Brasilia","Rio","Sao Paulo"], ans: 0, cat:"🌍 Geography" },
  { q: "Capital of Turkey?", opts: ["Ankara","Istanbul","Izmir"], ans: 0, cat:"🌍 Geography" },
  { q: "Capital of Australia?", opts: ["Canberra","Sydney","Melbourne"], ans: 0, cat:"🌍 Geography" },
  { q: "Largest island?", opts: ["Greenland","Madagascar","Borneo"], ans: 0, cat:"🌍 Geography" },
  { q: "Which country has most lakes?", opts: ["Canada","USA","Russia"], ans: 0, cat:"🌍 Geography" },
  { q: "Mount Fuji country?", opts: ["Japan","China","Korea"], ans: 0, cat:"🌍 Geography" },
  { q: "River Thames country?", opts: ["UK","USA","France"], ans: 0, cat:"🌍 Geography" },
  { q: "Largest gulf?", opts: ["Mexico","Persian","Bengal"], ans: 0, cat:"🌍 Geography" },
  { q: "Which continent Egypt?", opts: ["Africa","Asia","Europe"], ans: 0, cat:"🌍 Geography" },
  { q: "Sahara in which continent?", opts: ["Africa","Asia","Australia"], ans: 0, cat:"🌍 Geography" },
  { q: "Andes located?", opts: ["South America","Europe","Asia"], ans: 0, cat:"🌍 Geography" },
  { q: "Largest volcano?", opts: ["Mauna Loa","Etna","Fuji"], ans: 0, cat:"🌍 Geography" },
  { q: "Which pole colder?", opts: ["South","North","Same"], ans: 0, cat:"🌍 Geography" },

  // ================= MOVIES + BOOKS + HISTORY (111–150) =================
  { q: "Director of Inception?", opts: ["Nolan","Scott","Spielberg"], ans: 0, cat:"🎬 Movies" },
  { q: "Author of Harry Potter?", opts: ["Rowling","Tolkien","Lewis"], ans: 0, cat:"📚 Books" },
  { q: "Author of 1984?", opts: ["Orwell","Huxley","Bradbury"], ans: 0, cat:"📚 Books" },
  { q: "Discovery of India author?", opts: ["Nehru","Gandhi","Tagore"], ans: 0, cat:"📚 Books" },
  { q: "Ramayana author?", opts: ["Valmiki","Vyasa","Kalidas"], ans: 0, cat:"📚 Books" },
  { q: "Mahabharata author?", opts: ["Vyasa","Valmiki","Tulsidas"], ans: 0, cat:"📚 Books" },
  { q: "First Mughal emperor?", opts: ["Babur","Akbar","Humayun"], ans: 0, cat:"📜 History" },
  { q: "Battle of Plassey year?", opts: ["1757","1761","1748"], ans: 0, cat:"📜 History" },
  { q: "Quit India year?", opts: ["1942","1940","1939"], ans: 0, cat:"📜 History" },
  { q: "Last Mughal emperor?", opts: ["Bahadur Shah","Akbar","Babur"], ans: 0, cat:"📜 History" },
  { q: "Who discovered sea route India?", opts: ["Vasco da Gama","Columbus","Cook"], ans: 0, cat:"📜 History" },

  // fill remaining to reach exactly 150
  { q: "Who built Red Fort?", opts: ["Shah Jahan","Akbar","Babur"], ans: 0, cat:"📜 History" },
  { q: "Which empire Ashoka?", opts: ["Maurya","Gupta","Mughal"], ans: 0, cat:"📜 History" },
  { q: "Who wrote Arthashastra?", opts: ["Chanakya","Kalidas","Banabhatta"], ans: 0, cat:"📜 History" },
  { q: "Who was Akbar's finance minister?", opts: ["Todar Mal","Birbal","Tansen"], ans: 0, cat:"📜 History" },
  { q: "Capital of Maurya empire?", opts: ["Pataliputra","Taxila","Ujjain"], ans: 0, cat:"📜 History" },
  { q: "First English factory?", opts: ["Surat","Bombay","Madras"], ans: 0, cat:"📜 History" },
  { q: "Who founded Gupta empire?", opts: ["Chandragupta I","Samudragupta","Skandagupta"], ans: 0, cat:"📜 History" },
  { q: "Who was called Napoleon of India?", opts: ["Samudragupta","Ashoka","Harsha"], ans: 0, cat:"📜 History" },
  { q: "Which movie features Thanos?", opts: ["Avengers","Batman","Superman"], ans: 0, cat:"🎬 Movies" },
  { q: "Oscar award is from?", opts: ["USA","UK","France"], ans: 0, cat:"🎬 Movies" },
  { q: "Bollywood located?", opts: ["Mumbai","Delhi","Chennai"], ans: 0, cat:"🎬 Movies" },
  { q: "Which novel Sherlock Holmes author?", opts: ["Conan Doyle","Christie","Rowling"], ans: 0, cat:"📚 Books" },
  { q: "Who wrote Hamlet?", opts: ["Shakespeare","Milton","Chaucer"], ans: 0, cat:"📚 Books" },
  { q: "Who wrote Gitanjali?", opts: ["Tagore","Premchand","Nehru"], ans: 0, cat:"📚 Books" },
  { q: "Which movie won Oscar 2020?", opts: ["Parasite","Joker","1917"], ans: 0, cat:"🎬 Movies" },
    
  // ================= EXTRA 50 QUESTIONS (151–200) =================

  // 🔬 Advanced Science
  
  { q: "Which particle determines atomic number?", opts: ["Electron","Proton","Neutron"], ans: 1, cat:"🔬 Science" },
  { q: "What is the hardest natural substance?", opts: ["Diamond","Quartz","Graphite"], ans: 0, cat:"🔬 Science" },
  { q: "Which vitamin is essential for vision?", opts: ["Vitamin A","Vitamin D","Vitamin K"], ans: 0, cat:"🔬 Science" },
  { q: "Which scientist discovered radioactivity?", opts: ["Marie Curie","Einstein","Rutherford"], ans: 0, cat:"🔬 Science" },
  { q: "Unit of frequency?", opts: ["Hertz","Newton","Pascal"], ans: 0, cat:"🔬 Science" },
  { q: "Which blood group is universal donor?", opts: ["O negative","AB positive","A negative"], ans: 0, cat:"🔬 Science" },
  { q: "Which organelle produces energy?", opts: ["Nucleus","Mitochondria","Golgi body"], ans: 1, cat:"🔬 Science" },
  { q: "Which gas causes global warming most?", opts: ["CO2","Oxygen","Nitrogen"], ans: 0, cat:"🔬 Science" },
  { q: "Which scientist proposed laws of motion?", opts: ["Newton","Galileo","Kepler"], ans: 0, cat:"🔬 Science" },

  // 🇮🇳 India GK Advanced
  { q: "Which is India's longest dam?", opts: ["Hirakud","Bhakra","Tehri"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which state has highest GDP?", opts: ["Maharashtra","Gujarat","Tamil Nadu"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which is highest civilian gallantry award?", opts: ["Param Vir Chakra","Ashok Chakra","Vir Chakra"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which state has most national parks?", opts: ["MP","Assam","Karnataka"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Who was first Indian governor general?", opts: ["C. Rajagopalachari","Nehru","Mountbatten"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which Indian city known as Pink City?", opts: ["Jaipur","Udaipur","Jodhpur"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which Indian river flows west?", opts: ["Narmada","Ganga","Godavari"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which Indian state has most districts?", opts: ["UP","MP","Bihar"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which Indian state has lowest population density?", opts: ["Arunachal Pradesh","Sikkim","Goa"], ans: 0, cat:"🇮🇳 India GK" },
  { q: "Which Indian city called City of Lakes?", opts: ["Udaipur","Bhopal","Nainital"], ans: 0, cat:"🇮🇳 India GK" },

  // 🏛 Politics Advanced
  { q: "Which article gives Right to Constitutional Remedies?", opts: ["32","19","21"], ans: 0, cat:"🏛 Politics" },
  { q: "Who can dissolve Lok Sabha?", opts: ["President","PM","Speaker"], ans: 0, cat:"🏛 Politics" },
  { q: "Which schedule divides powers?", opts: ["7th","8th","9th"], ans: 0, cat:"🏛 Politics" },
  { q: "Which amendment lowered voting age to 18?", opts: ["61st","42nd","44th"], ans: 0, cat:"🏛 Politics" },
  { q: "Which body audits government spending?", opts: ["CAG","EC","UPSC"], ans: 0, cat:"🏛 Politics" },
  { q: "Who appoints Election Commissioners?", opts: ["President","PM","CJ"], ans: 0, cat:"🏛 Politics" },
  { q: "Which house controls money bills?", opts: ["Lok Sabha","Rajya Sabha","Both"], ans: 0, cat:"🏛 Politics" },
  { q: "Which article defines citizenship?", opts: ["5","10","15"], ans: 0, cat:"🏛 Politics" },

  // 🏏 Cricket Advanced
  { q: "Who has most Test centuries?", opts: ["Sachin","Smith","Kohli"], ans: 0, cat:"🏏 Cricket" },
  { q: "Who won first IPL orange cap?", opts: ["Shaun Marsh","Sachin","Warner"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which country hosted first T20 WC?", opts: ["South Africa","India","England"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which Indian bowler took 10 wickets in innings?", opts: ["Anil Kumble","Kapil Dev","Ashwin"], ans: 0, cat:"🏏 Cricket" },
  { q: "Who scored fastest ODI century?", opts: ["AB de Villiers","Corey Anderson","Afridi"], ans: 0, cat:"🏏 Cricket" },
  { q: "Which stadium largest capacity?", opts: ["Narendra Modi","MCG","Eden Gardens"], ans: 0, cat:"🏏 Cricket" },
  { q: "Who has most international wickets?", opts: ["Muralitharan","Warne","Wasim"], ans: 0, cat:"🏏 Cricket" },

  // 🌍 Geography Advanced
  { q: "Which strait separates Asia and Europe?", opts: ["Bosporus","Hormuz","Malacca"], ans: 0, cat:"🌍 Geography" },
  { q: "Which country largest area?", opts: ["Russia","Canada","China"], ans: 0, cat:"🌍 Geography" },
  { q: "Which capital lies on Danube river?", opts: ["Budapest","Paris","Berlin"], ans: 0, cat:"🌍 Geography" },
  { q: "Which plateau largest world?", opts: ["Tibetan","Deccan","Brazilian"], ans: 0, cat:"🌍 Geography" },
  { q: "Which ocean smallest?", opts: ["Arctic","Indian","Southern"], ans: 0, cat:"🌍 Geography" },

  // 🎬 Movies / 📚 Books / 📜 History Advanced
  { q: "Who directed Oppenheimer?", opts: ["Christopher Nolan","Spielberg","Villeneuve"], ans: 0, cat:"🎬 Movies" },
  { q: "Who wrote War and Peace?", opts: ["Tolstoy","Dostoevsky","Pushkin"], ans: 0, cat:"📚 Books" },
  { q: "Who was founder of Mughal empire?", opts: ["Babur","Akbar","Humayun"], ans: 0, cat:"📜 History" },
  { q: "French Revolution year?", opts: ["1789","1776","1804"], ans: 0, cat:"📜 History" },
  { q: "Who was first Emperor of Rome?", opts: ["Augustus","Julius Caesar","Nero"], ans: 0, cat:"📜 History" },
  { q: "Which book written by George Orwell?", opts: ["Animal Farm","Dune","Foundation"], ans: 0, cat:"📚 Books" },
  { q: "Who played Batman in Dark Knight trilogy?", opts: ["Christian Bale","Affleck","Keaton"], ans: 0, cat:"🎬 Movies" },
  { q: "Who discovered America?", opts: ["Columbus","Magellan","Cook"], ans: 0, cat:"📜 History" },
  { q: "Which empire built Colosseum?", opts: ["Roman","Greek","Ottoman"], ans: 0, cat:"📜 History" },
  { q: "Which novel written by Tolkien?", opts: ["Lord of the Rings","Harry Potter","Narnia"], ans: 0, cat:"📚 Books" }

];
  




// ─── Mobile Wrapper Component ──────────────────────────────────────────────────
function MobileGameWrapper({ title, children }) {
  const navigate = useNavigate();
  return (
    <div style={{ padding: "20px", minHeight: "100vh", background: "var(--bg-color)" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{ background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer", color: "var(--text-color)", marginRight: 16 }}
        >
          ←
        </button>
        <h2 style={{ margin: 0, fontSize: "1.5rem" }}>{title}</h2>
      </div>
      <div style={{ background: "var(--card-bg-color)", padding: "20px", borderRadius: "var(--radius-lg)", boxShadow: "var(--card-box-shadow)" }}>
        {children}
      </div>
    </div>
  );
}

// ─── 1. AI Tic Tac Toe ────────────────────────────────────────────────────────────
export function TicTacToe() {
  const [board, setBoard]           = useState(Array(9).fill(null));
  const [playerTurn, setPlayerTurn] = useState(true);
  const [status, setStatus]         = useState("Your turn (X)");
  const [scores, setScores]         = useState({ X:0, O:0, draws:0 });
  const [thinking, setThinking]     = useState(false);

  const lines = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];

  function getWinner(b) {
    for (const [a,bb,c] of lines)
      if (b[a] && b[a]===b[bb] && b[a]===b[c]) return b[a];
    return null;
  }

  function minimax(b, isMax) {
    const w = getWinner(b);
    if (w === "O") return 10;
    if (w === "X") return -10;
    if (b.every(Boolean)) return 0;
    if (isMax) {
      let best = -Infinity;
      b.forEach((cell, i) => { if (!cell) { b[i]="O"; best=Math.max(best,minimax(b,false)); b[i]=null; } });
      return best;
    } else {
      let best = Infinity;
      b.forEach((cell, i) => { if (!cell) { b[i]="X"; best=Math.min(best,minimax(b,true)); b[i]=null; } });
      return best;
    }
  }

  function bestMove(b) {
    let bestVal=-Infinity, bestIdx=-1;
    b.forEach((cell,i)=>{ if(!cell){ b[i]="O"; const val=minimax(b,false); b[i]=null; if(val>bestVal){bestVal=val;bestIdx=i;} } });
    return bestIdx;
  }

  function aiMove(b) {
    const empty = b.map((c,i)=>!c?i:null).filter(i=>i!==null);
    if (empty.length === 0) return -1;
    for (const i of empty) {
      const test = [...b]; test[i] = "O";
      if (getWinner(test)) return i;
    }
    for (const i of empty) {
      const test = [...b]; test[i] = "X";
      if (getWinner(test) && Math.random() < 0.6) return i;
    }
    if (Math.random() < 0.5) return bestMove(b);
    return empty[Math.floor(Math.random() * empty.length)];
  }

  function handleClick(i) {
    if (!playerTurn||board[i]||getWinner(board)||thinking) return;
    const nb=[...board]; nb[i]="X";
    const w=getWinner(nb);
    if(w){setBoard(nb);setStatus("🎉 You win!");setScores(s=>({...s,X:s.X+1}));setPlayerTurn(false);return;}
    if(nb.every(Boolean)){setBoard(nb);setStatus("🤝 Draw!");setScores(s=>({...s,draws:s.draws+1}));setPlayerTurn(false);return;}
    setBoard(nb);setPlayerTurn(false);setThinking(true);setStatus("🤖 AI thinking…");
    setTimeout(()=>{
      const nb2=[...nb]; const ai=aiMove(nb2); if(ai===-1) return; nb2[ai]="O";
      const w2=getWinner(nb2);
      if(w2){setBoard(nb2);setStatus("🤖 AI wins!");setScores(s=>({...s,O:s.O+1}));setThinking(false);return;}
      if(nb2.every(Boolean)){setBoard(nb2);setStatus("🤝 Draw!");setScores(s=>({...s,draws:s.draws+1}));setThinking(false);return;}
      setBoard(nb2);setPlayerTurn(true);setStatus("Your turn (X)");setThinking(false);
    },450);
  }

  function reset(){ setBoard(Array(9).fill(null));setPlayerTurn(true);setStatus("Your turn (X)");setThinking(false); }

  const winner=getWinner(board);
  const winLine=winner?lines.find(([a,b,c])=>board[a]&&board[a]===board[b]&&board[a]===board[c]):null;

  return (
    <MobileGameWrapper title="Tic Tac Toe">
      <div style={{textAlign:"center"}}>
        <div style={{display:"flex",gap:12,justifyContent:"center",marginBottom:16}}>
          {[["You (X)",scores.X,"var(--primary-color)","var(--primary-light)"],
            ["Draw",scores.draws,"var(--text-muted)","var(--bg-secondary)"],
            ["AI (O)",scores.O,"var(--secondary-color)","var(--secondary-light)"]].map(([lbl,val,c,bg])=>(
            <div key={lbl} style={{background:bg,borderRadius:"var(--radius-md)",padding:"10px 18px",minWidth:70}}>
              <div style={{fontSize:"1.4rem",fontWeight:800,color:c,fontFamily:"'DM Serif Display', serif"}}>{val}</div>
              <div style={{fontSize:"0.72rem",fontWeight:700,color:"var(--text-muted)",textTransform:"uppercase"}}>{lbl}</div>
            </div>
          ))}
        </div>
        <p style={{fontWeight:600,color:"var(--text-secondary-color)",marginBottom:12,minHeight:24}}>{status}</p>
        <div className="tic-grid" style={{justifyContent:"center"}}>
          {board.map((cell,i)=>{
            const inWinLine=winLine?.includes(i);
            return (
              <button key={i} className="tic-cell" onClick={()=>handleClick(i)} style={{
                color:cell==="X"?"var(--primary-color)":"var(--secondary-color)",fontWeight:800,
                background:inWinLine?(cell==="X"?"var(--primary-light)":"var(--secondary-light)"):undefined,
                borderColor:inWinLine?(cell==="X"?"var(--primary-color)":"var(--secondary-color)"):undefined,
                transform:inWinLine?"scale(1.08)":undefined,transition:"all 0.2s ease",
                cursor:(!cell&&playerTurn&&!winner)?"pointer":"default",
              }}>{cell}</button>
            );
          })}
        </div>
        <p style={{fontSize:"0.75rem",color:"var(--text-muted)",marginTop:8}}>AI difficulty: Balanced (beatable!)</p>
        <button className="btn secondary-btn" onClick={reset} style={{marginTop:8}}>New Game</button>
      </div>
    </MobileGameWrapper>
  );
}

// ─── 2. Number Guessing Game ──────────────────────────────────────────────────────
export function NumberGuess() {
  const [target]              = useState(()=>Math.floor(Math.random()*100)+1);
  const [guess, setGuess]     = useState("");
  const [history, setHistory] = useState([]);
  const [won, setWon]         = useState(false);

  function submit() {
    const n=parseInt(guess);
    if(isNaN(n)||n<1||n>100) return;
    let hint="";
    if(n===target){hint="🎉 Correct!";setWon(true);}
    else if(n<target) hint=n<target-20?"📈 Way too low!":"📈 A bit low";
    else hint=n>target+20?"📉 Way too high!":"📉 A bit high";
    setHistory(h=>[{n,hint},...h]); setGuess("");
  }

  return (
    <MobileGameWrapper title="Number Guess">
        <div className="game-wrapper" style={{textAlign:"center"}}>
        <p style={{color:"var(--text-muted)",fontSize:"0.875rem",marginBottom:20}}>
            Guess a number between <strong>1 – 100</strong>. Unlimited tries!
        </p>
        {!won?(
            <div style={{display:"flex",gap:10,justifyContent:"center",marginBottom:20}}>
            <input type="number" min={1} max={100} value={guess}
                onChange={e=>setGuess(e.target.value)} onKeyDown={e=>e.key==="Enter"&&submit()}
                placeholder="Your guess…" style={{width:140,textAlign:"center",fontSize:"1.1rem"}}/>
            <button className="btn primary-btn" onClick={submit}>Guess</button>
            </div>
        ):(
            <div>
            <p style={{fontSize:"1.4rem",fontFamily:"'DM Serif Display', serif",color:"var(--primary-color)",marginBottom:8}}>
                🎉 Got it in {history.length} {history.length===1?"try":"tries"}!
            </p>
            <button className="btn primary-btn" onClick={()=>window.location.reload()} style={{marginBottom:16}}>Play Again</button>
            </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:8,maxHeight:180,overflowY:"auto"}}>
            {history.map((h,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                background:"var(--card-bg-secondary)",border:"1px solid var(--border-subtle)",
                borderRadius:"var(--radius-md)",padding:"8px 16px",fontSize:"0.9rem"}}>
                <span style={{fontWeight:700,color:"var(--text-color)"}}>→ {h.n}</span>
                <span style={{color:"var(--text-secondary-color)"}}>{h.hint}</span>
            </div>
            ))}
        </div>
        </div>
    </MobileGameWrapper>
  );
}

// ─── 3. Memory Match ──────────────────────────────────────────────────────────────
export function MemoryMatch() {
  const EMOJIS=["🌸","🦋","🎯","🍀","⭐","🌙","🔥","💎"];
  function newDeck(){ return [...EMOJIS,...EMOJIS].sort(()=>Math.random()-0.5).map((e,i)=>({id:i,emoji:e,flipped:false,matched:false})); }
  const [cards,setCards]     = useState(newDeck);
  const [flipped,setFlipped] = useState([]);
  const [moves,setMoves]     = useState(0);
  const [locked,setLocked]   = useState(false);
  const allMatched=cards.every(c=>c.matched);

  function flip(id){
    if(locked||flipped.length===2) return;
    const card=cards.find(c=>c.id===id);
    if(!card||card.flipped||card.matched) return;
    const newFlipped=[...flipped,id];
    setCards(cs=>cs.map(c=>c.id===id?{...c,flipped:true}:c)); setFlipped(newFlipped);
    if(newFlipped.length===2){
      setMoves(m=>m+1); setLocked(true);
      const [a,b]=newFlipped.map(fid=>cards.find(c=>c.id===fid));
      if(a.emoji===b.emoji){setCards(cs=>cs.map(c=>newFlipped.includes(c.id)?{...c,matched:true}:c));setFlipped([]);setLocked(false);}
      else{setTimeout(()=>{setCards(cs=>cs.map(c=>newFlipped.includes(c.id)?{...c,flipped:false}:c));setFlipped([]);setLocked(false);},900);}
    }
  }

  return (
    <MobileGameWrapper title="Memory Match">
        <div style={{textAlign:"center"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <span style={{color:"var(--text-muted)",fontSize:"0.875rem"}}>Moves: <strong style={{color:"var(--text-color)"}}>{moves}</strong></span>
            {allMatched?<span style={{color:"var(--primary-color)",fontWeight:700}}>🎉 Solved in {moves} moves!</span>:<span style={{color:"var(--text-muted)",fontSize:"0.875rem"}}>Find all pairs</span>}
            <button className="btn secondary-btn" style={{padding:"6px 14px",fontSize:"0.8rem"}} onClick={()=>{setCards(newDeck());setFlipped([]);setMoves(0);setLocked(false);}}>Reset</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,maxWidth:320,margin:"0 auto"}}>
            {cards.map(card=>(
            <button key={card.id} onClick={()=>flip(card.id)} style={{
                height:72,fontSize:"1.6rem",borderRadius:"var(--radius-md)",
                border:card.matched?"2px solid var(--secondary-color)":"1.5px solid var(--border-color)",
                background:card.matched?"var(--secondary-light)":card.flipped?"var(--primary-light)":"var(--bg-secondary)",
                cursor:card.matched||card.flipped?"default":"pointer",transition:"all 0.2s ease",
            }}>{card.flipped||card.matched?card.emoji:""}</button>
            ))}
        </div>
        </div>
    </MobileGameWrapper>
  );
}

// ─── 4. Word Scramble ─────────────────────────────────────────────────────────────
export function WordScramble() {
  const WORDS_PER_LEVEL = 5;
  const MAX_LEVEL = 20;

  const [level, setLevel]           = useState(1);
  const [levelWords, setLevelWords] = useState([]);
  const [wordIdx, setWordIdx]       = useState(0);
  const [scrambled, setScrambled]   = useState("");
  const [input, setInput]           = useState("");
  const [result, setResult]         = useState(null);
  const [score, setScore]           = useState(0);
  const [levelComplete, setLevelComplete] = useState(false);
  const [streak, setStreak]         = useState(0);
  const [showHint, setShowHint]     = useState(false);

  function scramble(w) {
    const arr = w.replace(/-/g,"").split("");
    let s;
    do { s = [...arr].sort(()=>Math.random()-0.5).join(""); } while (s === w.replace(/-/g,"") && arr.length > 1);
    return s;
  }

  function loadLevel(lvl) {
    const pool = WORD_BANK.filter(w => w.level === lvl);
    const shuffled = [...pool].sort(()=>Math.random()-0.5).slice(0, WORDS_PER_LEVEL);
    setLevelWords(shuffled);
    setWordIdx(0);
    setLevelComplete(false);
    setInput("");
    setResult(null);
    setShowHint(false);
    return shuffled;
  }

  useEffect(() => { loadLevel(level); }, [level]);

  useEffect(() => {
    if (levelWords.length > 0 && levelWords[wordIdx]) {
      setScrambled(scramble(levelWords[wordIdx].word));
      setInput("");
      setResult(null);
      setShowHint(false);
    }
  }, [wordIdx, levelWords]);

  function check() {
    if (!levelWords[wordIdx]) return;
    const cleanWord = levelWords[wordIdx].word.replace(/-/g,"");
    if (input.trim().toLowerCase() === cleanWord || input.trim().toLowerCase() === levelWords[wordIdx].word) {
      setResult("correct");
      setScore(s => s + 10 * level);
      setStreak(s => s + 1);
    } else {
      setResult("wrong");
      setStreak(0);
    }
  }

  function next() {
    const nextIdx = wordIdx + 1;
    if (nextIdx >= WORDS_PER_LEVEL) { setLevelComplete(true); }
    else { setWordIdx(nextIdx); }
  }

  const currentWord = levelWords[wordIdx];
  const difficultyLabel = level <= 5 ? "Easy" : level <= 10 ? "Medium" : level <= 15 ? "Hard" : "Expert";
  const difficultyColor = level <= 5 ? "var(--secondary-color)" : level <= 10 ? "var(--accent-color)" : level <= 15 ? "var(--primary-color)" : "#e53e3e";

  if (levelComplete) {
    return (
      <MobileGameWrapper title="Word Scramble">
        <div className="game-wrapper" style={{textAlign:"center",padding:"20px 0"}}>
          <div style={{fontSize:52,marginBottom:12}}>🏆</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.6rem",color:"var(--primary-color)",marginBottom:6}}>Level {level} Complete!</p>
          <p style={{color:"var(--text-muted)",marginBottom:4}}>You unscrambled all {WORDS_PER_LEVEL} words!</p>
          <p style={{fontWeight:700,color:"var(--text-color)",marginBottom:20}}>Total Score: <span style={{color:"var(--primary-color)"}}>{score}</span></p>
          {level < MAX_LEVEL ? (
            <button className="btn primary-btn" onClick={()=>setLevel(l=>l+1)}>Level {level + 1} →</button>
          ) : (
            <div>
              <p style={{color:"var(--secondary-color)",fontWeight:700,fontSize:"1.1rem",marginBottom:12}}>🎉 You've mastered all 20 levels!</p>
              <button className="btn secondary-btn" onClick={()=>{setLevel(1);setScore(0);setStreak(0);}}>Play Again</button>
            </div>
          )}
        </div>
      </MobileGameWrapper>
    );
  }

  if (!currentWord) return null;

  return (
    <MobileGameWrapper title="Word Scramble">
      <div className="game-wrapper" style={{textAlign:"center"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{textAlign:"left"}}>
            <div style={{fontSize:"0.7rem",fontWeight:700,textTransform:"uppercase",color:"var(--text-muted)"}}>Level</div>
            <div style={{fontWeight:800,color:"var(--primary-color)",fontSize:"1.1rem"}}>{level} <span style={{fontSize:"0.7rem",color:difficultyColor,fontWeight:700}}>({difficultyLabel})</span></div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:"0.7rem",fontWeight:700,textTransform:"uppercase",color:"var(--text-muted)"}}>Word</div>
            <div style={{fontWeight:700,color:"var(--text-color)"}}>{wordIdx + 1} / {WORDS_PER_LEVEL}</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:"0.7rem",fontWeight:700,textTransform:"uppercase",color:"var(--text-muted)"}}>Streak 🔥</div>
            <div style={{fontWeight:800,color:"var(--accent-color)"}}>{streak}</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:"0.7rem",fontWeight:700,textTransform:"uppercase",color:"var(--text-muted)"}}>Score</div>
            <div style={{fontWeight:700,color:"var(--primary-color)"}}>{score}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:4,marginBottom:20}}>
          {Array.from({length:WORDS_PER_LEVEL}).map((_,i)=>(
            <div key={i} style={{flex:1,height:5,borderRadius:3,background:i<wordIdx?"var(--primary-color)":i===wordIdx?"var(--accent-color)":"var(--border-color)",transition:"background 0.3s"}}/>
          ))}
        </div>
        <p style={{color:"var(--text-muted)",fontSize:"0.875rem",marginBottom:8}}>
          Hint: {showHint ? currentWord.hint : <span style={{cursor:"pointer",color:"var(--primary-color)",textDecoration:"underline"}} onClick={()=>setShowHint(true)}>Show hint</span>}
        </p>
        <div style={{fontFamily:"'DM Serif Display', serif",fontSize:"clamp(1.6rem,4vw,2.2rem)",letterSpacing:"0.3em",color:"var(--text-color)",marginBottom:20,padding:"16px 24px",background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",display:"inline-block",minWidth:200}}>
          {scrambled}
        </div>
        <div style={{fontSize:"0.75rem",color:"var(--text-muted)",marginBottom:16}}>{currentWord.word.length} letters</div>
        <div style={{display:"flex",gap:10,justifyContent:"center",marginBottom:14}}>
          <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&(result==="correct"?next():check())}
            placeholder="Unscramble it…" style={{width:220,textAlign:"center"}} autoFocus/>
          <button className="btn primary-btn" onClick={check} disabled={result==="correct"}>Check</button>
        </div>
        {result==="correct" && (
          <div style={{marginBottom:12}}>
            <p style={{color:"var(--secondary-color)",fontWeight:700,marginBottom:8}}>✅ Correct! {streak > 1 ? `🔥 ${streak}x streak!` : ""} +{10 * level} pts</p>
            <button className="btn primary-btn" onClick={next}>{wordIdx + 1 >= WORDS_PER_LEVEL ? "Finish Level 🏆" : "Next Word →"}</button>
          </div>
        )}
        {result==="wrong" && (<p style={{color:"var(--primary-color)",fontWeight:700,marginBottom:12}}>❌ Try again!</p>)}
        <div style={{marginTop:20,borderTop:"1px solid var(--border-color)",paddingTop:16}}>
          <p style={{fontSize:"0.75rem",color:"var(--text-muted)",marginBottom:8}}>Jump to level:</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:4,justifyContent:"center"}}>
            {Array.from({length:MAX_LEVEL}).map((_,i)=>(
              <button key={i} onClick={()=>setLevel(i+1)} style={{
                width:30,height:30,fontSize:"0.7rem",fontWeight:700,borderRadius:"var(--radius-sm)",
                border:"1.5px solid var(--border-color)",cursor:"pointer",
                background:level===i+1?"var(--primary-color)":"var(--bg-secondary)",
                color:level===i+1?"white":"var(--text-secondary-color)",
              }}>{i+1}</button>
            ))}
          </div>
        </div>
      </div>
    </MobileGameWrapper>
  );
}

// ─── 5. Snake Game ────────────────────────────────────────────────────────────────
export function SnakeGame() {
  const GRID = 20;
  const CELL = 18;
  const initSnake = [{x:10,y:10},{x:9,y:10},{x:8,y:10}];
  const [snake, setSnake]     = useState(initSnake);
  const [food, setFood]       = useState({x:15,y:10});
  const [dir, setDir]         = useState({x:1,y:0});
  const [running, setRunning] = useState(false);
  const [dead, setDead]       = useState(false);
  const [score, setScore]     = useState(0);
  const [best, setBest]       = useState(0);
  const dirRef                = useRef({x:1,y:0});
  const snakeRef              = useRef(initSnake);
  const foodRef               = useRef({x:15,y:10});
  const deadRef               = useRef(false);

  function randFood(s) {
    let f;
    do { f = {x:Math.floor(Math.random()*GRID),y:Math.floor(Math.random()*GRID)}; }
    while (s.some(seg=>seg.x===f.x&&seg.y===f.y));
    return f;
  }

  useEffect(() => {
    const handleKey = e => {
      const map = {ArrowUp:{x:0,y:-1},ArrowDown:{x:0,y:1},ArrowLeft:{x:-1,y:0},ArrowRight:{x:1,y:0},
                   w:{x:0,y:-1},s:{x:0,y:1},a:{x:-1,y:0},d:{x:1,y:0}};
      const nd = map[e.key];
      if (nd && !(nd.x===-dirRef.current.x&&nd.y===0) && !(nd.y===-dirRef.current.y&&nd.x===0)) {
        dirRef.current = nd; setDir(nd);
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => {
      if (deadRef.current) return;
      const s = snakeRef.current;
      const d = dirRef.current;
      const head = {x:(s[0].x+d.x+GRID)%GRID, y:(s[0].y+d.y+GRID)%GRID};
      if (s.some(seg=>seg.x===head.x&&seg.y===head.y)) {
        deadRef.current = true;
        setDead(true); setRunning(false);
        setScore(sc => { setBest(b=>Math.max(b,sc)); return sc; });
        return;
      }
      let newSnake;
      if (head.x===foodRef.current.x && head.y===foodRef.current.y) {
        newSnake = [head,...s];
        const nf = randFood(newSnake);
        foodRef.current = nf; setFood(nf);
        setScore(sc => sc + 10);
      } else {
        newSnake = [head,...s.slice(0,-1)];
      }
      snakeRef.current = newSnake; setSnake([...newSnake]);
    }, 130);
    return () => clearInterval(id);
  }, [running]);

  function reset() {
    snakeRef.current = initSnake; dirRef.current = {x:1,y:0};
    const f = {x:15,y:10}; foodRef.current = f; deadRef.current = false;
    setSnake(initSnake); setDir({x:1,y:0}); setFood(f);
    setDead(false); setScore(0); setRunning(false);
  }

  const size = GRID * CELL;
  return (
    <MobileGameWrapper title="Snake">
      <div style={{textAlign:"center"}}>
        <div style={{display:"flex",gap:16,justifyContent:"center",marginBottom:12}}>
          <div style={{background:"var(--primary-light)",borderRadius:"var(--radius-md)",padding:"8px 18px"}}>
            <div style={{fontSize:"1.3rem",fontWeight:800,color:"var(--primary-color)"}}>{score}</div>
            <div style={{fontSize:"0.7rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Score</div>
          </div>
          <div style={{background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",padding:"8px 18px"}}>
            <div style={{fontSize:"1.3rem",fontWeight:800,color:"var(--text-color)"}}>{best}</div>
            <div style={{fontSize:"0.7rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Best</div>
          </div>
        </div>
        <div style={{position:"relative",display:"inline-block",border:"2px solid var(--border-color)",borderRadius:"var(--radius-md)",overflow:"hidden",background:"var(--bg-secondary)"}}>
          <svg width={size} height={size}>
            {Array.from({length:GRID+1}).map((_,i)=>(
              <g key={i}>
                <line x1={i*CELL} y1={0} x2={i*CELL} y2={size} stroke="var(--border-subtle)" strokeWidth="0.5"/>
                <line x1={0} y1={i*CELL} x2={size} y2={i*CELL} stroke="var(--border-subtle)" strokeWidth="0.5"/>
              </g>
            ))}
            <circle cx={food.x*CELL+CELL/2} cy={food.y*CELL+CELL/2} r={CELL/2-2} fill="var(--primary-color)" opacity="0.85"/>
            <text x={food.x*CELL+CELL/2} y={food.y*CELL+CELL/2+5} textAnchor="middle" fontSize="11">🍎</text>
            {snake.map((seg,i)=>(
              <rect key={i} x={seg.x*CELL+1} y={seg.y*CELL+1} width={CELL-2} height={CELL-2}
                rx="3" fill={i===0?"var(--primary-color)":"var(--secondary-color)"} opacity={i===0?1:0.75}/>
            ))}
          </svg>
          {!running && !dead && (
            <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.4)",borderRadius:"var(--radius-md)"}}>
              <div style={{color:"white",textAlign:"center"}}>
                <div style={{fontSize:"1.3rem",fontWeight:700,marginBottom:8}}>🐍 Snake</div>
                <button className="btn primary-btn" onClick={()=>setRunning(true)}>▶ Start</button>
                <p style={{fontSize:"0.75rem",marginTop:8,opacity:0.8}}>Arrow keys or WASD</p>
              </div>
            </div>
          )}
          {dead && (
            <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.5)",borderRadius:"var(--radius-md)"}}>
              <div style={{color:"white",textAlign:"center"}}>
                <div style={{fontSize:"1.5rem",marginBottom:4}}>💀 Game Over</div>
                <div style={{fontSize:"1.1rem",marginBottom:12}}>Score: {score}</div>
                <button className="btn primary-btn" onClick={reset}>Try Again</button>
              </div>
            </div>
          )}
        </div>
        {running && (
          <div style={{marginTop:12,display:"flex",justifyContent:"center"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,44px)",gridTemplateRows:"repeat(3,44px)",gap:4}}>
              <div/>
              <button onClick={()=>{dirRef.current={x:0,y:-1};setDir({x:0,y:-1});}} style={{borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border-color)",background:"var(--bg-secondary)",cursor:"pointer",fontWeight:700,fontSize:"1rem"}}>↑</button>
              <div/>
              <button onClick={()=>{dirRef.current={x:-1,y:0};setDir({x:-1,y:0});}} style={{borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border-color)",background:"var(--bg-secondary)",cursor:"pointer",fontWeight:700,fontSize:"1rem"}}>←</button>
              <button onClick={()=>setRunning(r=>!r)} style={{borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border-color)",background:"var(--primary-light)",cursor:"pointer",fontSize:"0.75rem",fontWeight:700,color:"var(--primary-color)"}}>⏸</button>
              <button onClick={()=>{dirRef.current={x:1,y:0};setDir({x:1,y:0});}} style={{borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border-color)",background:"var(--bg-secondary)",cursor:"pointer",fontWeight:700,fontSize:"1rem"}}>→</button>
              <div/>
              <button onClick={()=>{dirRef.current={x:0,y:1};setDir({x:0,y:1});}} style={{borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border-color)",background:"var(--bg-secondary)",cursor:"pointer",fontWeight:700,fontSize:"1rem"}}>↓</button>
              <div/>
            </div>
          </div>
        )}
      </div>
    </MobileGameWrapper>
  );
}

// ─── 6. Reaction Time Test ────────────────────────────────────────────────────────
export function ReactionTest() {
  const [phase, setPhase]           = useState("idle");
  const [reactionTime, setReactionTime] = useState(null);
  const [times, setTimes]           = useState([]);
  const [startTime, setStartTime]   = useState(null);
  const timerRef                    = useRef(null);

  function startTest() {
    setPhase("waiting"); setReactionTime(null);
    const delay = 2000 + Math.random() * 4000;
    timerRef.current = setTimeout(() => { setPhase("ready"); setStartTime(performance.now()); }, delay);
  }

  function handleClick() {
    if (phase === "idle" || phase === "result") { startTest(); }
    else if (phase === "waiting") { clearTimeout(timerRef.current); setPhase("idle"); }
    else if (phase === "ready") {
      const rt = Math.round(performance.now() - startTime);
      setReactionTime(rt); setTimes(t => [...t, rt].slice(-10)); setPhase("result");
    }
  }

  const avg = times.length ? Math.round(times.reduce((a,b)=>a+b,0)/times.length) : null;
  const best = times.length ? Math.min(...times) : null;

  function getRating(ms) {
    if (ms < 200) return {label:"⚡ Superhuman!", color:"var(--secondary-color)"};
    if (ms < 250) return {label:"🎯 Excellent!", color:"var(--primary-color)"};
    if (ms < 350) return {label:"👍 Good", color:"var(--accent-color)"};
    if (ms < 500) return {label:"😊 Average", color:"var(--text-muted)"};
    return {label:"🐢 Slow — try again!", color:"var(--text-secondary-color)"};
  }

  const bgColor = phase === "ready" ? "var(--secondary-color)" : phase === "waiting" ? "var(--accent-color)" : "var(--primary-color)";
  const textMsg = phase === "idle" ? "Click to Start" : phase === "waiting" ? "Wait for green…" : phase === "ready" ? "CLICK NOW! 🟢" : `${reactionTime}ms`;

  return (
    <MobileGameWrapper title="Reaction Test">
      <div style={{textAlign:"center"}}>
        <p style={{color:"var(--text-muted)",fontSize:"0.875rem",marginBottom:16}}>Click as fast as you can when the button turns green! 🟢</p>
        <div onClick={handleClick} style={{width:"100%",maxWidth:400,height:160,margin:"0 auto 20px",borderRadius:"var(--radius-xl)",background:bgColor,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",transition:"background 0.2s ease",userSelect:"none",boxShadow:"0 4px 20px rgba(0,0,0,0.15)"}}>
          <div style={{color:"white",fontWeight:800,fontSize:"clamp(1.2rem,3vw,1.8rem)",fontFamily:"'DM Serif Display', serif"}}>{textMsg}</div>
        </div>
        {phase === "result" && reactionTime && (
          <div style={{marginBottom:16}}>
            <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"2rem",color:"var(--primary-color)",margin:"0 0 4px"}}>{reactionTime}ms</p>
            <p style={{fontWeight:700,color:getRating(reactionTime).color,marginBottom:12}}>{getRating(reactionTime).label}</p>
            <button className="btn primary-btn" onClick={startTest}>Try Again</button>
          </div>
        )}
        {times.length > 0 && (
          <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap",marginTop:12}}>
            <div style={{background:"var(--primary-light)",borderRadius:"var(--radius-md)",padding:"10px 18px"}}>
              <div style={{fontWeight:800,color:"var(--primary-color)",fontSize:"1.2rem"}}>{best}ms</div>
              <div style={{fontSize:"0.7rem",color:"var(--text-muted)",fontWeight:700}}>BEST</div>
            </div>
            <div style={{background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",padding:"10px 18px"}}>
              <div style={{fontWeight:800,color:"var(--text-color)",fontSize:"1.2rem"}}>{avg}ms</div>
              <div style={{fontSize:"0.7rem",color:"var(--text-muted)",fontWeight:700}}>AVERAGE</div>
            </div>
            <div style={{background:"var(--secondary-light)",borderRadius:"var(--radius-md)",padding:"10px 18px"}}>
              <div style={{fontWeight:800,color:"var(--secondary-color)",fontSize:"1.2rem"}}>{times.length}</div>
              <div style={{fontSize:"0.7rem",color:"var(--text-muted)",fontWeight:700}}>ATTEMPTS</div>
            </div>
          </div>
        )}
        {times.length > 1 && (
          <div style={{marginTop:16,display:"flex",gap:4,alignItems:"flex-end",justifyContent:"center",height:50}}>
            {times.map((t,i)=>{
              const maxT = Math.max(...times);
              const h = (t/maxT)*44;
              return <div key={i} title={`${t}ms`} style={{width:20,height:h,borderRadius:"3px 3px 0 0",background:t===best?"var(--secondary-color)":"var(--primary-color)",opacity:0.7+0.3*(i/times.length),transition:"all 0.3s"}}/>;
            })}
          </div>
        )}
      </div>
    </MobileGameWrapper>
  );
}

// ─── 7. Math Sprint ──────────────────────────────────────────────────────────────
export function MathSprint() {
  const MAX_LEVEL    = 40;
  const QS_PER_LEVEL = 5;

  function drawQuestions(lvl) {
    const pool = [...(MATH_LEVELS[lvl] || MATH_LEVELS[1])];
    return pool.sort(() => Math.random() - 0.5).slice(0, QS_PER_LEVEL);
  }
  function getTimer(lvl) { return getLevelConfig(lvl).timer; }
  function normalize(s) { return String(s).toLowerCase().replace(/\s+/g,"").replace(/[−–]/g,"-"); }

  const [level, setLevel]             = useState(1);
  const [levelPool, setLevelPool]     = useState([]);
  const [questionNum, setQuestionNum] = useState(0);
  const [input, setInput]             = useState("");
  const [totalScore, setTotalScore]   = useState(0);
  const [levelScore, setLevelScore]   = useState(0);
  const [lives, setLives]             = useState(3);
  const [timeLeft, setTimeLeft]       = useState(null);
  const [running, setRunning]         = useState(false);
  const [gameState, setGameState]     = useState("menu");
  const [streak, setStreak]           = useState(0);
  const [feedback, setFeedback]       = useState(null);
  const [history, setHistory]         = useState([]);
  const [showHint, setShowHint]       = useState(false);
  const inputRef  = useRef(null);
  const timerRef  = useRef(null);
  const livesRef  = useRef(3);

  const currentQ = levelPool[questionNum] || null;

  function startLevel(lvl) {
    const pool = drawQuestions(lvl);
    setLevel(lvl); setLevelPool(pool); setQuestionNum(0); setLevelScore(0);
    setLives(3); livesRef.current = 3; setStreak(0); setInput(""); setFeedback(null);
    setShowHint(false); setTimeLeft(getTimer(lvl)); setRunning(true); setGameState("playing");
    setTimeout(() => inputRef.current?.focus(), 100);
  }

  useEffect(() => {
    if (!running || gameState !== "playing") { clearInterval(timerRef.current); return; }
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) { clearInterval(timerRef.current); handleTimeUp(); return 0; }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [running, questionNum, gameState]);

  function handleTimeUp() {
    const correctAns = currentQ?.a || "—";
    setFeedback({ type:"timeout", msg:`⏱ Time up! Answer: ${correctAns}` });
    setShowHint(false);
    const newLives = livesRef.current - 1;
    livesRef.current = newLives; setLives(newLives); setStreak(0);
    if (newLives <= 0) { setRunning(false); setGameState("gameover"); }
    else { setTimeout(() => advanceQuestion(), 1200); }
  }

  function advanceQuestion() {
    const next = questionNum + 1;
    clearInterval(timerRef.current);
    if (next >= QS_PER_LEVEL) { setRunning(false); setFeedback(null); setGameState("levelDone"); }
    else {
      setQuestionNum(next); setInput(""); setFeedback(null);
      setShowHint(false); setTimeLeft(getTimer(level));
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }

  function checkAnswer() {
    if (!currentQ || !running) return;
    const raw = input.trim();
    if (!raw) return;
    clearInterval(timerRef.current);
    const isCorrect = normalize(raw) === normalize(currentQ.a);
    if (isCorrect) {
      const timeBonus   = Math.max(0, Math.floor(timeLeft / 5));
      const streakBonus = streak >= 4 ? 3 : streak >= 2 ? 2 : 1;
      const pts         = (10 + timeBonus) * streakBonus * Math.ceil(level / 5);
      setTotalScore(s => s + pts); setLevelScore(s => s + pts); setStreak(s => s + 1);
      setFeedback({ type:"correct", msg: streak >= 3 ? `🔥 +${pts}pts (${streak+1}x streak!)` : `✅ +${pts}pts` });
      setTimeout(() => advanceQuestion(), 600);
    } else {
      const newLives = livesRef.current - 1;
      livesRef.current = newLives; setLives(newLives); setStreak(0);
      setFeedback({ type:"wrong", msg:`❌ Correct: ${currentQ.a}` }); setInput("");
      if (newLives <= 0) { setRunning(false); setGameState("gameover"); }
      else { setTimeout(() => advanceQuestion(), 900); }
    }
  }

  const cfg      = getLevelConfig(level);
  const maxTimer = getTimer(level);
  const isQuant  = level >= 31;

  function levelBand(l) {
    if (l <= 5)  return { bg:"var(--secondary-light)", c:"var(--secondary-color)", label:"Arithmetic" };
    if (l <= 10) return { bg:"var(--accent-light)",    c:"var(--accent-color)",    label:"Algebra I" };
    if (l <= 15) return { bg:"var(--primary-light)",   c:"var(--primary-color)",   label:"Algebra II" };
    if (l <= 20) return { bg:"#e0f0ff",                c:"#2563eb",                label:"Geometry" };
    if (l <= 25) return { bg:"#f3e8ff",                c:"#7c3aed",                label:"Adv Algebra" };
    if (l <= 30) return { bg:"#fef3c7",                c:"#d97706",                label:"Calculus" };
    return               { bg:"#fee2e2",               c:"#dc2626",                label:"Quant" };
  }

  if (gameState === "menu") {
    return (
      <MobileGameWrapper title="Math Sprint">
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:6}}>🧮</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.35rem",marginBottom:4}}>Math Sprint</p>
          <p style={{color:"var(--text-muted)",marginBottom:20,fontSize:"0.875rem"}}>40 levels · 5 questions each · 3 lives per level</p>
          <div style={{display:"flex",gap:6,justifyContent:"center",flexWrap:"wrap",marginBottom:16}}>
            {[{r:"1-5",l:"Arithmetic"},{r:"6-15",l:"Algebra"},{r:"16-25",l:"Geometry"},{r:"26-30",l:"Calculus"},{r:"31-40",l:"Quant ⏱2min"}].map(b=>(
              <span key={b.r} style={{fontSize:"0.65rem",fontWeight:700,background:"var(--bg-secondary)",border:"1px solid var(--border-color)",borderRadius:"var(--radius-full)",padding:"3px 10px",color:"var(--text-muted)"}}>{b.r}: {b.l}</span>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:5,maxWidth:500,margin:"0 auto 20px"}}>
            {Array.from({length:MAX_LEVEL}).map((_,i)=>{
              const l=i+1; const done=history.some(h=>h.level===l); const band=levelBand(l);
              return (
                <button key={l} onClick={()=>startLevel(l)} title={getLevelConfig(l).label} style={{
                  padding:"7px 0",borderRadius:"var(--radius-sm)",fontWeight:700,fontSize:"0.78rem",
                  border:`1.5px solid ${done?band.c:"var(--border-color)"}`,cursor:"pointer",
                  background:done?band.bg:"var(--bg-secondary)",color:done?band.c:"var(--text-muted)",
                  position:"relative",transition:"all 0.15s",
                }}>
                  {l}{done && <span style={{position:"absolute",top:-3,right:-3,fontSize:"0.5rem",lineHeight:1}}>✓</span>}
                </button>
              );
            })}
          </div>
          {totalScore > 0 && <p style={{color:"var(--primary-color)",fontWeight:700,marginBottom:12,fontSize:"0.9rem"}}>🏆 Total score: {totalScore}</p>}
          <div style={{display:"flex",gap:10,justifyContent:"center"}}>
            <button className="btn primary-btn" onClick={()=>{setTotalScore(0);setHistory([]);startLevel(1);}}>Start from Level 1</button>
            {history.length > 0 && <button className="btn secondary-btn" onClick={()=>startLevel(Math.min(history.length+1,MAX_LEVEL))}>Resume L{Math.min(history.length+1,MAX_LEVEL)}</button>}
          </div>
        </div>
      </MobileGameWrapper>
    );
  }
  if (gameState === "gameover") {
    return (
      <MobileGameWrapper title="Math Sprint">
        <div style={{textAlign:"center",padding:"20px 0"}}>
          <div style={{fontSize:52,marginBottom:8}}>💀</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.7rem",color:"var(--primary-color)",margin:"0 0 6px"}}>Game Over!</p>
          <p style={{color:"var(--text-muted)",marginBottom:4}}>Stopped at Level {level} — {getLevelConfig(level).label}</p>
          <p style={{fontWeight:700,fontSize:"1.2rem",marginBottom:20}}>Total Score: <span style={{color:"var(--primary-color)"}}>{totalScore}</span></p>
          <div style={{display:"flex",gap:10,justifyContent:"center"}}>
            <button className="btn primary-btn" onClick={()=>startLevel(level)}>Retry Level {level}</button>
            <button className="btn secondary-btn" onClick={()=>setGameState("menu")}>Level Select</button>
          </div>
        </div>
      </MobileGameWrapper>
    );
  }
  if (gameState === "victory") {
    return (
      <MobileGameWrapper title="Math Sprint">
        <div style={{textAlign:"center",padding:"20px 0"}}>
          <div style={{fontSize:52,marginBottom:8}}>🏆</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.7rem",color:"var(--primary-color)",margin:"0 0 8px"}}>Math Legend! 🔥</p>
          <p style={{color:"var(--text-muted)",marginBottom:4}}>You conquered all 40 levels!</p>
          <p style={{fontWeight:700,fontSize:"1.4rem",marginBottom:20}}>Final Score: <span style={{color:"var(--primary-color)"}}>{totalScore}</span></p>
          <button className="btn primary-btn" onClick={()=>{setTotalScore(0);setHistory([]);setGameState("menu");}}>Play Again</button>
        </div>
      </MobileGameWrapper>
    );
  }
  if (gameState === "levelDone") {
    const nextLvl = level + 1;
    const nextCfg = nextLvl <= MAX_LEVEL ? getLevelConfig(nextLvl) : null;
    return (
      <MobileGameWrapper title="Math Sprint">
        <div style={{textAlign:"center",padding:"16px 0"}}>
          <div style={{fontSize:48,marginBottom:6}}>⭐</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.6rem",color:"var(--primary-color)",margin:"0 0 4px"}}>Level {level} Complete!</p>
          <p style={{color:"var(--text-muted)",marginBottom:4,fontSize:"0.875rem"}}>{getLevelConfig(level).label}</p>
          <p style={{fontWeight:700,fontSize:"1.1rem",marginBottom:20}}>+{levelScore} pts &nbsp;·&nbsp; Total: <span style={{color:"var(--primary-color)"}}>{totalScore}</span></p>
          {nextCfg ? (
            <div>
              <div style={{background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",padding:"12px 20px",display:"inline-block",marginBottom:16,textAlign:"left"}}>
                <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase",marginBottom:4}}>Next — Level {nextLvl}</div>
                <div style={{fontWeight:700,color:"var(--text-color)",marginBottom:4}}>{nextCfg.label}</div>
                <div style={{fontSize:"0.75rem",color:"var(--primary-color)"}}>⏱ {nextCfg.timer >= 60 ? `${nextCfg.timer/60} min` : `${nextCfg.timer}s`} per question</div>
              </div>
              <br/>
              <button className="btn primary-btn" onClick={()=>{setHistory(h=>[...h,{level,score:levelScore}]);startLevel(nextLvl);}}>Level {nextLvl} →</button>
            </div>
          ) : (
            <button className="btn primary-btn" onClick={()=>setGameState("victory")}>🏆 See Final Results</button>
          )}
          <br/>
          <button className="btn secondary-btn" style={{marginTop:12}} onClick={()=>setGameState("menu")}>Level Select</button>
        </div>
      </MobileGameWrapper>
    );
  }
  const band = levelBand(level);
  const urgentTime = isQuant ? 30 : Math.min(8, Math.floor(maxTimer * 0.25));
  const warnTime   = isQuant ? 60 : Math.min(15, Math.floor(maxTimer * 0.5));
  return (
    <MobileGameWrapper title="Math Sprint">
      <div style={{textAlign:"center"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <div style={{textAlign:"left"}}>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Level</div>
            <div style={{fontWeight:800,color:band.c,fontSize:"1.1rem"}}>{level}<span style={{fontSize:"0.6rem",color:"var(--text-muted)",marginLeft:3}}>/{MAX_LEVEL}</span></div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Lives</div>
            <div style={{fontSize:"1rem"}}>{Array.from({length:3}).map((_,i)=><span key={i}>{i<lives?"❤️":"🖤"}</span>)}</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Q</div>
            <div style={{fontWeight:700,color:"var(--text-color)",fontSize:"0.9rem"}}>{questionNum+1}/{QS_PER_LEVEL}</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700,textTransform:"uppercase"}}>Score</div>
            <div style={{fontWeight:700,color:band.c,fontSize:"0.9rem"}}>{totalScore}</div>
          </div>
        </div>
        <div style={{display:"inline-block",background:band.bg,color:band.c,fontWeight:700,fontSize:"0.7rem",padding:"3px 12px",borderRadius:"var(--radius-full)",marginBottom:10}}>{band.label} · {cfg.label}</div>
        <div style={{display:"flex",gap:5,justifyContent:"center",marginBottom:12}}>
          {Array.from({length:QS_PER_LEVEL}).map((_,i)=>(<div key={i} style={{width:9,height:9,borderRadius:"50%",background:i<questionNum?"var(--secondary-color)":i===questionNum?"var(--primary-color)":"var(--border-color)",border:i===questionNum?"2px solid var(--primary-color)":"2px solid transparent",transition:"all 0.3s"}}/>))}
        </div>
        <div style={{height:7,background:"var(--border-color)",borderRadius:4,marginBottom:14,overflow:"hidden"}}>
          <div style={{height:"100%",borderRadius:4,transition:"width 1s linear, background 0.3s",width:`${(timeLeft/maxTimer)*100}%`,background:timeLeft<=urgentTime?"#e53e3e":timeLeft<=warnTime?"var(--accent-color)":"var(--secondary-color)"}}/>
        </div>
        <div style={{fontFamily:"'DM Serif Display', serif",fontSize:isQuant?"clamp(1.8rem,3vw,2.4rem)":"clamp(2.2rem,4vw,3rem)",fontWeight:800,lineHeight:1,marginBottom:2,transition:"color 0.3s",color:timeLeft<=urgentTime?"#e53e3e":timeLeft<=warnTime?"var(--accent-color)":"var(--text-color)"}}>
          {isQuant ? `${Math.floor(timeLeft/60)}:${String(timeLeft%60).padStart(2,"0")}` : timeLeft}
        </div>
        <div style={{fontSize:"0.65rem",color:"var(--text-muted)",marginBottom:14}}>{isQuant ? "minutes remaining" : "seconds"}</div>
        <div style={{background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",padding:"16px 20px",marginBottom:12,minHeight:isQuant?72:56,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Serif Display', serif",fontSize:isQuant?"clamp(1rem,2.2vw,1.3rem)":"clamp(1.4rem,3.5vw,2rem)",color:"var(--text-color)",lineHeight:1.4,textAlign:"center"}}>{currentQ?.q || ""}</div>
        {currentQ?.hint && !showHint && (<button onClick={()=>setShowHint(true)} style={{background:"none",border:"none",fontSize:"0.75rem",color:"var(--primary-color)",cursor:"pointer",textDecoration:"underline",marginBottom:6}}>Show hint</button>)}
        {showHint && currentQ?.hint && (<div style={{fontSize:"0.8rem",color:"var(--accent-color)",marginBottom:8,fontWeight:600}}>💡 {currentQ.hint}</div>)}
        <div style={{minHeight:24,marginBottom:8,fontSize:"0.9rem",fontWeight:700,color:feedback?.type==="correct"?"var(--secondary-color)":feedback?.type==="timeout"?"var(--accent-color)":"var(--primary-color)"}}>{feedback?.msg || (streak>1?`🔥 ${streak}x streak!`:"")}</div>
        <div style={{display:"flex",gap:8,justifyContent:"center"}}>
          <input ref={inputRef} type="text" value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&checkAnswer()} placeholder={isQuant?"Type your answer…":"Answer…"} style={{width:isQuant?220:160,textAlign:"center",fontSize:isQuant?"1rem":"1.3rem",fontWeight:700}}/>
          <button className="btn primary-btn" onClick={checkAnswer} style={{fontSize:"1rem",padding:"10px 18px"}}>→</button>
        </div>
        {isQuant && (<p style={{fontSize:"0.7rem",color:"var(--text-muted)",marginTop:8}}>Type exact answer (e.g. "25", "6 h", "1/6")</p>)}
        <button className="btn secondary-btn" style={{marginTop:14,fontSize:"0.72rem"}} onClick={()=>{clearInterval(timerRef.current);setGameState("menu");}}>← Menu</button>
      </div>
    </MobileGameWrapper>
  );
}

// ─── 8. 2-Player Trivia Duel ────────────────────────────────────────────────────────
export function TwoPlayerDuel() {
  const ROUNDS = 10;
  const ROUND_TIME = 15;
  const [gameState, setGameState]       = useState("lobby");
  const [questions, setQuestions]       = useState([]);
  const [roundIdx, setRoundIdx]         = useState(0);
  const [scores, setScores]             = useState([0, 0]);
  const [timeLeft, setTimeLeft]         = useState(ROUND_TIME);
  const [answered, setAnswered]         = useState(null);
  const [countdown, setCountdown]       = useState(3);
  const [roundHistory, setRoundHistory] = useState([]);
  const timerRef    = useRef(null);
  const answeredRef = useRef(null);
  const [p1name, setP1name] = useState("Player 1");
  const [p2name, setP2name] = useState("Player 2");

  useEffect(() => {
    if (gameState !== "playing") return;
    const handleKey = e => {
      if (answeredRef.current) return;
      const p1map = { a:0, s:1, d:2 };
      const p2map = { ArrowLeft:0, ArrowDown:1, ArrowRight:2 };
      const q = questions[roundIdx];
      if (!q) return;
      if (e.key.toLowerCase() in p1map) { e.preventDefault(); buzzer(0, p1map[e.key.toLowerCase()], q); }
      else if (e.key in p2map) { e.preventDefault(); buzzer(1, p2map[e.key], q); }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [gameState, roundIdx, questions]);

  function buzzer(player, choice, q) {
    if (answeredRef.current) return;
    clearInterval(timerRef.current);
    const correct = choice === q.ans;
    const result = { player, choice, correct };
    answeredRef.current = result; setAnswered(result);
    setScores(s => { const ns=[...s]; ns[player] += correct ? 2 : -1; return ns; });
    setRoundHistory(h => [...h, { q: q.q, winner: correct ? player : null, correct }]);
    setTimeout(() => nextRound(), 1800);
  }

  function handleTimeUp() {
    if (answeredRef.current) return;
    const result = { player: null, choice: null, correct: false };
    answeredRef.current = result; setAnswered(result);
    setRoundHistory(h => [...h, { q: questions[roundIdx]?.q, winner: null, correct: false }]);
    setTimeout(() => nextRound(), 1500);
  }

  function nextRound() {
    answeredRef.current = null;
    const next = roundIdx + 1;
    if (next >= ROUNDS) { setGameState("final"); }
    else { setRoundIdx(next); setAnswered(null); setTimeLeft(ROUND_TIME); }
  }

  useEffect(() => {
    if (gameState !== "playing") return;
    answeredRef.current = null; setAnswered(null); setTimeLeft(ROUND_TIME);
  }, [roundIdx, gameState]);

  useEffect(() => {
    if (gameState !== "playing" || answered) { clearInterval(timerRef.current); return; }
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft(t => { if (t <= 1) { clearInterval(timerRef.current); handleTimeUp(); return 0; } return t - 1; });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [gameState, answered, roundIdx]);

  function startGame() {
    const shuffled = [...TRIVIA_QUESTIONS].sort(() => Math.random() - 0.5).slice(0, ROUNDS);
    setQuestions(shuffled); setRoundIdx(0); setScores([0, 0]); setRoundHistory([]);
    answeredRef.current = null; setAnswered(null); setCountdown(3); setGameState("countdown");
    let c = 3;
    const cid = setInterval(() => { c--; setCountdown(c); if (c <= 0) { clearInterval(cid); setGameState("playing"); } }, 800);
  }

  const q = questions[roundIdx];
  const names = [p1name, p2name];
  const colors = ["var(--primary-color)","var(--secondary-color)"];
  const optionKeys = [["A","S","D"],["←","↓","→"]];

  if (gameState === "lobby") {
    return (
      <MobileGameWrapper title="Trivia Duel">
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:8}}>⚔️</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.4rem",marginBottom:4}}>2-Player Trivia Duel</p>
          <p style={{color:"var(--text-muted)",marginBottom:24,maxWidth:460,margin:"0 auto 24px"}}>Same keyboard, two players. Buzz first with the correct answer to earn points. Wrong answer = −1 point!</p>
          <div style={{display:"flex",gap:16,justifyContent:"center",marginBottom:24,flexWrap:"wrap"}}>
            <div style={{background:"var(--primary-light)",borderRadius:"var(--radius-lg)",padding:"20px 24px",minWidth:200}}>
              <div style={{fontSize:"1.4rem",marginBottom:8}}>🟦 Player 1</div>
              <input value={p1name} onChange={e=>setP1name(e.target.value)} placeholder="Player 1 name" style={{textAlign:"center",fontWeight:700,width:"100%",marginBottom:12}}/>
              <div style={{fontSize:"0.75rem",color:"var(--primary-color)",fontWeight:700}}>Keys: A / S / D</div>
              <div style={{fontSize:"0.7rem",color:"var(--text-muted)",marginTop:4}}>A = option 1 &nbsp; S = option 2 &nbsp; D = option 3</div>
            </div>
            <div style={{background:"var(--secondary-light)",borderRadius:"var(--radius-lg)",padding:"20px 24px",minWidth:200}}>
              <div style={{fontSize:"1.4rem",marginBottom:8}}>🟥 Player 2</div>
              <input value={p2name} onChange={e=>setP2name(e.target.value)} placeholder="Player 2 name" style={{textAlign:"center",fontWeight:700,width:"100%",marginBottom:12}}/>
              <div style={{fontSize:"0.75rem",color:"var(--secondary-color)",fontWeight:700}}>Keys: ← / ↓ / →</div>
              <div style={{fontSize:"0.7rem",color:"var(--text-muted)",marginTop:4}}>← = option 1 &nbsp; ↓ = option 2 &nbsp; → = option 3</div>
            </div>
          </div>
          <div style={{background:"var(--bg-secondary)",borderRadius:"var(--radius-md)",padding:"12px 20px",display:"inline-block",marginBottom:20}}>
            <div style={{fontSize:"0.8rem",color:"var(--text-muted)"}}>🎯 {ROUNDS} rounds &nbsp;|&nbsp; ⏱ {ROUND_TIME}s each &nbsp;|&nbsp; ✅ Correct = +2 &nbsp;|&nbsp; ❌ Wrong = −1</div>
          </div>
          <br/>
          <button className="btn primary-btn" style={{fontSize:"1.1rem",padding:"12px 32px"}} onClick={startGame}>Start Duel! ⚔️</button>
        </div>
      </MobileGameWrapper>
    );
  }
  if (gameState === "countdown") {
    return (
      <MobileGameWrapper title="Trivia Duel">
        <div style={{textAlign:"center",padding:"40px 0"}}>
          <div style={{fontFamily:"'DM Serif Display', serif",fontSize:"6rem",color:"var(--primary-color)",lineHeight:1,marginBottom:8}}>{countdown === 0 ? "GO!" : countdown}</div>
          <p style={{color:"var(--text-muted)"}}>Get ready…</p>
        </div>
      </MobileGameWrapper>
    );
  }
  if (gameState === "final") {
    const winner = scores[0] > scores[1] ? 0 : scores[1] > scores[0] ? 1 : null;
    return (
      <MobileGameWrapper title="Trivia Duel">
        <div style={{textAlign:"center",padding:"16px 0"}}>
          <div style={{fontSize:52,marginBottom:8}}>{winner===null?"🤝":"🏆"}</div>
          <p style={{fontFamily:"'DM Serif Display', serif",fontSize:"1.7rem",color:winner!==null?colors[winner]:"var(--text-color)",margin:"0 0 8px"}}>{winner===null?"It's a draw!":`${names[winner]} wins!`}</p>
          <div style={{display:"flex",gap:16,justifyContent:"center",marginBottom:24,flexWrap:"wrap"}}>
            {[0,1].map(p=>(
              <div key={p} style={{background:p===0?"var(--primary-light)":"var(--secondary-light)",borderRadius:"var(--radius-lg)",padding:"20px 28px",minWidth:140}}>
                <div style={{fontSize:"2.2rem",fontWeight:800,color:colors[p],fontFamily:"'DM Serif Display', serif"}}>{scores[p]}</div>
                <div style={{fontWeight:700,color:colors[p]}}>{names[p]}</div>
                {winner===p&&<div style={{fontSize:"1.2rem",marginTop:4}}>🏆</div>}
              </div>
            ))}
          </div>
          <div style={{maxHeight:240,overflowY:"auto",marginBottom:20,textAlign:"left"}}>
            {roundHistory.map((r,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 12px",background:i%2===0?"var(--bg-secondary)":"transparent",borderRadius:"var(--radius-sm)",fontSize:"0.8rem"}}>
                <span style={{minWidth:20,color:"var(--text-muted)",fontWeight:700}}>{i+1}.</span>
                <span style={{flex:1,color:"var(--text-color)"}}>{r.q}</span>
                <span style={{fontWeight:700,color:r.winner===0?colors[0]:r.winner===1?colors[1]:"var(--text-muted)"}}>{r.winner===null?"⏱ Time":r.winner===0?`🟦 ${names[0]}`:`🟥 ${names[1]}`}</span>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"center"}}>
            <button className="btn primary-btn" onClick={startGame}>Rematch! ⚔️</button>
            <button className="btn secondary-btn" onClick={()=>setGameState("lobby")}>Change Players</button>
          </div>
        </div>
      </MobileGameWrapper>
    );
  }
  if (!q) return null;
  return (
    <MobileGameWrapper title="Trivia Duel">
      <div>
        <div style={{display:"grid",gridTemplateColumns:"1fr auto 1fr",gap:8,alignItems:"center",marginBottom:16}}>
          <div style={{background:"var(--primary-light)",borderRadius:"var(--radius-lg)",padding:"12px 16px",textAlign:"center",border:answered?.player===0?"3px solid var(--primary-color)":"3px solid transparent",transition:"border 0.2s"}}>
            <div style={{fontSize:"1.8rem",fontWeight:800,color:"var(--primary-color)",fontFamily:"'DM Serif Display', serif"}}>{scores[0]}</div>
            <div style={{fontWeight:700,color:"var(--primary-color)",fontSize:"0.85rem"}}>{names[0]}</div>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)"}}>A / S / D</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontFamily:"'DM Serif Display', serif",fontSize:"2rem",fontWeight:800,color:timeLeft<=5?"#e53e3e":"var(--text-color)"}}>{timeLeft}</div>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)",fontWeight:700}}>ROUND {roundIdx+1}/{ROUNDS}</div>
          </div>
          <div style={{background:"var(--secondary-light)",borderRadius:"var(--radius-lg)",padding:"12px 16px",textAlign:"center",border:answered?.player===1?"3px solid var(--secondary-color)":"3px solid transparent",transition:"border 0.2s"}}>
            <div style={{fontSize:"1.8rem",fontWeight:800,color:"var(--secondary-color)",fontFamily:"'DM Serif Display', serif"}}>{scores[1]}</div>
            <div style={{fontWeight:700,color:"var(--secondary-color)",fontSize:"0.85rem"}}>{names[1]}</div>
            <div style={{fontSize:"0.65rem",color:"var(--text-muted)"}}>← / ↓ / →</div>
          </div>
        </div>
        <div style={{height:6,background:"var(--border-color)",borderRadius:3,marginBottom:20,overflow:"hidden"}}>
          <div style={{height:"100%",width:`${(timeLeft/ROUND_TIME)*100}%`,borderRadius:3,transition:"width 1s linear",background:timeLeft<=5?"#e53e3e":timeLeft<=10?"var(--accent-color)":"var(--secondary-color)"}}/>
        </div>
        <div style={{textAlign:"center",fontSize:"0.75rem",fontWeight:700,color:"var(--text-muted)",marginBottom:10,textTransform:"uppercase",letterSpacing:"0.05em"}}>{q.cat}</div>
        <div style={{textAlign:"center",fontFamily:"'DM Serif Display', serif",fontSize:"clamp(1.1rem,2.5vw,1.5rem)",color:"var(--text-color)",marginBottom:20,lineHeight:1.4,minHeight:56,padding:"0 8px"}}>{q.q}</div>
        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
          {q.opts.map((opt, oi) => {
            const isCorrect = oi === q.ans;
            const p1picked = answered?.player===0 && answered?.choice===oi;
            const p2picked = answered?.player===1 && answered?.choice===oi;
            let bg = "var(--bg-secondary)";
            let border = "1.5px solid var(--border-color)";
            if (answered) {
              if (isCorrect) { bg = "var(--secondary-light)"; border = "2px solid var(--secondary-color)"; }
              else if (p1picked || p2picked) { bg = "#fef2f2"; border = "2px solid #e53e3e"; }
            }
            return (
              <div key={oi} style={{display:"grid",gridTemplateColumns:"32px 1fr 32px",alignItems:"center",gap:8,background:bg,border,borderRadius:"var(--radius-md)",padding:"12px 14px",transition:"all 0.25s"}}>
                <div style={{background:"var(--primary-light)",borderRadius:"var(--radius-sm)",padding:"4px 0",textAlign:"center",fontSize:"0.7rem",fontWeight:700,color:"var(--primary-color)"}}>
                  {optionKeys[0][oi]}{p1picked && <div style={{fontSize:"0.65rem"}}>{answered.correct?"✅":"❌"}</div>}
                </div>
                <div style={{textAlign:"center",fontWeight:600,color:"var(--text-color)",fontSize:"0.95rem"}}>
                  {opt}{answered && isCorrect && <span style={{marginLeft:8,color:"var(--secondary-color)"}}>✓</span>}
                </div>
                <div style={{background:"var(--secondary-light)",borderRadius:"var(--radius-sm)",padding:"4px 0",textAlign:"center",fontSize:"0.7rem",fontWeight:700,color:"var(--secondary-color)"}}>
                  {optionKeys[1][oi]}{p2picked && <div style={{fontSize:"0.65rem"}}>{answered.correct?"✅":"❌"}</div>}
                </div>
              </div>
            );
          })}
        </div>
        {answered && (
          <div style={{textAlign:"center",padding:"10px",borderRadius:"var(--radius-md)",marginTop:8,background:answered.player===null?"var(--bg-secondary)":answered.correct?"var(--secondary-light)":"#fef2f2",border:`1.5px solid ${answered.player===null?"var(--border-color)":answered.correct?"var(--secondary-color)":"#e53e3e"}`}}>
            <span style={{fontWeight:700,fontSize:"0.95rem",color:answered.player===null?"var(--text-muted)":answered.correct?"var(--secondary-color)":"#e53e3e"}}>
              {answered.player===null ? "⏱ Time's up! No one scored." : answered.correct ? `🎉 ${names[answered.player]} got it! +2 pts` : `❌ ${names[answered.player]} was wrong! −1 pt. Next up…`}
            </span>
          </div>
        )}
        {!answered && (<div style={{textAlign:"center",fontSize:"0.8rem",color:"var(--text-muted)"}}>🟦 {names[0]}: <strong>A / S / D</strong> &nbsp;&nbsp; 🟥 {names[1]}: <strong>← / ↓ / →</strong></div>)}
      </div>
    </MobileGameWrapper>
  );
}